import React, { useEffect, useState } from "react";
import {
  getAllMatchesOddsSoccerAPI,
  getAllMatchesOddsTennisAPI,
} from "../service/soccer&tennis";
import { getAllMatchesOddsCricketAPI } from "../service/cricket";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import HosrseRacing from "./static/HosrseRacing";
import GreyHoundRacing from "./static/GreyHoundRacing";
import Lottery from "./static/Lottery";
import Tips from "./static/Tips";
import VirtualSports from "./static/VirtualSports";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import PrivacyPolicy from "../components/PrivacyPolicy";
import RulesAndRegulation from "../components/RulesAndRegulation";
import KYC from "../components/KYC";

import { original } from "@reduxjs/toolkit";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import toast from "react-hot-toast";
import CasinoLoader from "./universalCasino/CasinoLoader";
import Loader from "../components/Loader";

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { game } = useParams();
  const [selectedTab, setSelectedTab] = React.useState("ALL");
  const [casinoList, setCasinoList] = React.useState([
    { name: "ALL", value: "ALL", active: true },
    {
      name: "OUR CASINO",
      value: "OUR CASINO",
      enum: [
        { name: "ALL CASINO", value: "ALL", active: true },
        { name: "TEEN PATTI", value: "TEEN PATTI" },
        { name: "POKER", value: "POKER" },
        { name: "BACCARAT", value: "BACCARAT" },
        { name: "DRAGON TIGER", value: "DRAGON TIGER" },
        { name: "32CARDS", value: "32CARDS" },

        { name: "ANDAR BAHAR", value: "ANDAR BAHAR" },
        { name: "LUCKY 7", value: "LUCKY 7" },
        { name: "3 CARD JUDGEMENT", value: "3 CARD JUDGEMENT" },
        { name: "CASINO WAR", value: "CASINO WAR" },
        { name: "WARLI", value: "WARLI" },
        { name: "BOLLYWOOD", value: "BOLLYWOOD" },
        { name: "LOTTERY", value: "LOTTERY" },
        { name: "RACE", value: "RACE" },
        { name: "OTHER", value: "OTHER" },
      ],
    },
    {
      name: "OUR VIRTUAL",
      enum: [
        { name: "ALL", value: "ALL", active: true },
        { name: "V-TEENPATTI", value: "V-TEENPATTI" },
        { name: "V-LUCKY7", value: "V-LUCKY7" },
        { name: "V-OTHER", value: "V-OTHER" },
      ],
    },
  ]);
  const [selectedModal, setSelectedModal] = React.useState(null);
  const modalMap = {
    pp: <PrivacyPolicy close={setSelectedModal} />,
    tandc: null,
    rar: <RulesAndRegulation close={setSelectedModal} />,
    kyc: <KYC close={setSelectedModal} />,
  };
  const [showCasinoLoader, setShowCasinoLoader] = React.useState(false);
  const { id } = useParams();
  const idMap = {
    4: "cricket",
    2: "tennis",
    1: "soccer",
    7: "horseRacing",
    4339: "greyhoundRacing",
    66104: "lottery",
    0: "liveCasino",
    5: "virtualSports",
    6: "tips",
  };
  const [selectedGame, setSelectedGame] = React.useState(
    game ? game : id ? idMap[id] : "cricket"
  );
  const [casinoListMap, setCasinoListMap] = React.useState({
    ALL: [
      {
        name: "JOKER TEEN PATTI",
        link: "/casino/generic/UNI_JOKER_TEEN_PATTI",
        image:
          "/assets/casino/Joker teenpatti.jpeg",
      },
      {
        name: "MUFLIS TEEN PATTI",
        link: "/casino/UNI_MUFLIS_TEEN_PATTI",
        image: "/assets/casino/muflisteenpatti-01.jpeg",
      },
      {
        name: "1DAY TEEN PATTI",
        link: "/casino/UNI_1DAY_TEEN_PATTI",
        image: "/assets/casino/1 Day teenpatti.jpeg",
      },
      // {
      //   name: "DTL TEENPATTI",
      //   link: "/casino/generic/UNI_DTL_TEENPATTI",
      //   image: "/assets/casino/DTL.jpeg",
      // },
      {
        name: "20-20 TEENPATTI",
        link: "/casino/distributed/back/generic/UNI_20_20_TEENPATTI",
        image:
          "/assets/casino/20-20 teenpatti.jpeg",
      },
      {
        name: "20-20 POKER - A",
        link: "/casino/poker/generic/UNI_20_20_POKER_A",
        image: "/assets/casino/Poker.jpeg",
      },
      // {
      //   name: "20-20 POKER - B",
      //   link: "/casino/generic/UNI_20_20_POKER_B",
      //   image: "/assets/casino/Poker.jpeg",
      // },
      // {
      //   name: "29 CARD BACCARAT",
      //   link: "/casino/poker/generic/UNI_29_CARD_BACCARAT",
      //   image: "/assets/casino/Baccarat.jpeg",
      // },
      // {
      //   name: "BACCARAT - A",
      //   link: "/casino/baccarat/generic/UNI_BACCARAT_A",
      //   image: "/assets/casino/Baccarat.jpeg",
      // },
      {
        name: "BACCARAT",
        link: "/casino/baccarat/generic/UNI_BACCARAT",
        image: "/assets/casino/Baccarat.jpeg",
      },
      // {
      //   name: "BACCARAT - C",
      //   link: "/casino/baccarat/generic/UNI_BACCARAT_C",
      //   image: "/assets/casino/Baccarat.jpeg",
      // },
      {
        name: "DRAGON TIGER",
        link: "/casino/generic/UNI_DRAGON_TIGER",
        image: "/assets/casino/dragon tiger-01.jpeg",
      },
      {
        name: "20-20 DRAGON TIGER",
        link: "/casino/distributed/back/generic/UNI_20_20_DRAGON_TIGER",
        image:
          "/assets/casino/Dragontiger.jpeg",
      },
      // {
      //   name: "FAST DRAGON TIGER",
      //   link: "/casino/fas/UNI_FAST_DRAGON_TIGER",
      //   image:
      //     "/assets/casino/Dragontiger.jpeg",
      // },
      {
        name: "1 DAY DRAGON TIGER",
        link: "/casino/UNI_1_DAY_DRAGON_TIGER",
        image:
          "/assets/casino/1 Day Dragon tiger.jpeg",
      },
      {
        name: "DTL - A",
        link: "/casino/dtl/UNI_DTL_TEENPATTI",
        image: "/assets/casino/DTL.jpeg",
      },
      // {
      //   name: "32 CARDS - B",
      //   link: "/casino/generic/UNI_32_CARDS_B",
      //   image: "/assets/casino/32 cards.jpeg",
      // },
      {
        name: "32 CARDS - A",
        link: "/casino/generic/UNI_32_CARDS_A",
        image: "/assets/casino/32 cards.jpeg",
      },
      {
        name: "ANDAR BAHAR - A",
        link: "/casino/ab/UNI_ANDAR_BAHAR_A",
        image: "/assets/casino/Andar Bahar.jpeg",
      },
      // {
      //   name: "ANDAR BAHAR - C",
      //   link: "/casino/ab/UNI_ANDAR_BAHAR_C",
      //   image: "/assets/casino/Andar Bahar.jpeg",
      // },
      {
        name: "LUCKY 7 - A",
        link: "/casino/distributed/back/generic/UNI_LUCKY_7_A",
        image: "/assets/casino/Lucky-7.jpeg",
      },
      // {
      //   name: "FAST LUCKY - 7",
      //   link: "/casino/fas/UNI_FAST_LUCKY_7",
      //   image: "/assets/casino/Lucky-7.jpeg",
      // },
      // {
      //   name: "LUCKY 7 - B",
      //   link: "/casino/generic/UNI_LUCKY_7_B",
      //   image: "/assets/casino/Lucky-7.jpeg",
      // },
      // {
      //   name: "3 CARD JUDGEMENT - A",
      //   link: "/casino/UNI_3_CARD_JUDGMENT_A",
      //   image:
      //     "https://queenexch.com/api/users/images/3Card Judgement-min-min.png",
      // },
      // {
      //   name: "CASINO WAR",
      //   link: "/casino/UNI_CASINO_WAR",
      //   image: "https://queenexch.com/api/users/images/CasinoWar-min.png",
      // },
      // {
      //   name: "INSTANT WORLI",
      //   link: "",
      //   image: "https://queenexch.com/api/users/images/Instant Worli-min.png",
      // },
      // {
      //   name: "BOLLYWOOD CASINO",
      //   link: "/casino/bollywoodCasino",
      //   image:
      //     "https://queenexch.com/api/users/images/Bollywood Casino 2-min.png",
      // },
      // {
      //   name: "INA MINA DIKA",
      //   link: "/casino/aaa/UNI_INA_MINA_DIKA",
      //   image:
      //     "https://queenexch.com/api/users/images/InaMinaDika-01-min-min.png",
      // },
      {
        name: "AMAR AKBAR ANTHONY",
        link: "/casino/aaa/UNI_AMAR_AKBAR_ANTHONY",
        image:
          "/assets/casino/AmarAkbarAnthony-01.jpeg",
      },
      // {
      //   name: "LOTTERY",
      //   link: "",
      //   image: "https://queenexch.com/api/users/images/Lottery 1-min.png",
      // },
      // {
      //   name: "20-20 CARD RACE",
      //   link: "/casino/generic/UNI_20_20_CARD_RACE",
      //   image: "/assets/casino/CardRace.jpeg",
      // },
      // {
      //   name: "1 CARD METER",
      //   link: "/casino/distributed/back/generic/UNI_1_CARD_METER",
      //   image: "https://queenexch.com/api/users/images/1 Card Meter-min.png",
      // },
      // {
      //   name: "1 CARD 20-20",
      //   link: "/casino/baccarat/generic/UNI_1_CARD_20_20",
      //   image: "https://queenexch.com/api/users/images/1 Card-min.png",
      // },
      // {
      //   name: "TRIO",
      //   link: "",
      //   image: "https://queenexch.com/api/users/images/Trio-min.png",
      // },
      // {
      //   name: "KBC",
      //   link: "",
      //   image: "https://queenexch.com/api/users/images/KBC-min.png",
      // },
      // {
      //   name: "CASINO METER",
      //   link: "",
      //   image: "https://queenexch.com/api/users/images/CasinoMeter-min.png",
      // },
      // {
      //   name: "EVOLUTION",
      //   link: "",
      //   image:
      //     "https://universe-studio.s3.ap-south-1.amazonaws.com/abevolution+gaming-min.png",
      // },
      // {
      //   name: "TVBET",
      //   link: "",
      //   image:
      //     "https://universe-studio.s3.ap-south-1.amazonaws.com/abevolution+gaming-2-min.png",
      // },
      // {
      //   name: "BETGAMES CASINO",
      //   link: "",
      //   image:
      //     "https://universe-studio.s3.ap-south-1.amazonaws.com/abevolution+gaming-3-min.png",
      // },
      // {
      //   name: "EZUGI",
      //   link: "",
      //   image:
      //     "https://universe-studio.s3.ap-south-1.amazonaws.com/Ezugi+(4)-min.png",
      // },
      // {
      //   name: "VIMAAN",
      //   link: "",
      //   image: "https://uniique444.com/api/users/images/Vimaan.png",
      // },
      {
        name: "20-20 CARD RACE",
        link: "/casino/generic/UNI_20_20_CARD_RACE",
        image: "/assets/casino/CardRace.jpeg",
      },
      // {
      //   name: "BALLOON",
      //   link: "",
      //   image: "/assets/casino/Balloon.jpeg",
      // },
      {
        name: "HEADS & TAILS",
        link: "/casino/UNI_HEADS_AND_TAILS",
        image: "/assets/casino/Head n Tails.jpeg",
      },
      {
        name: "LUCKY 0 TO 9",
        link: "/casino/UNI_LUCKY_0_TO_9",
        image: "/assets/casino/Lucky 0 to 9.jpeg",
      },
    ],
    "ANDAR BAHAR": [
      {
        name: "ANDAR BAHAR - A",
        link: "/casino/ab/UNI_ANDAR_BAHAR_A",
        image: "/assets/casino/Andar Bahar.jpeg",
      },
      // {
      //   name: "ANDAR BAHAR - C",
      //   link: "/casino/ab/UNI_ANDAR_BAHAR_C",
      //   image: "/assets/casino/Andar Bahar.jpeg",
      // },
    ],
    "LUCKY 7": [
      {
        name: "LUCKY 7 - A",
        link: "/casino/distributed/back/generic/UNI_LUCKY_7_A",
        image: "/assets/casino/Lucky-7.jpeg",
      },
      // {
      //   name: "FAST LUCKY - 7",
      //   link: "/casino/fas/UNI_FAST_LUCKY_7",
      //   image: "/assets/casino/Lucky-7.jpeg",
      // },
      // {
      //   name: "LUCKY 7 - B",
      //   link: "/casino/generic/UNI_LUCKY_7_B",
      //   image: "/assets/casino/Lucky-7.jpeg",
      // },
    ],
    "TEEN PATTI": [
      {
        name: "POINT TEEN PATTI",
        link: "/casino/generic/UNI_POINT_TEEN_PATTI",
        image:
          "/assets/casino/20-20 teenpatti.jpeg",
      },
      {
        name: "JOKER TEEN PATTI",
        link: "/casino/generic/UNI_JOKER_TEEN_PATTI",
        image:
          "/assets/casino/Joker teenpatti.jpeg",
      },
      {
        name: "MUFLIS TEEN PATTI",
        link: "/casino/UNI_MUFLIS_TEEN_PATTI",
        image: "/assets/casino/muflisteenpatti-01.jpeg",
      },
      {
        name: "1DAY TEEN PATTI",
        link: "/casino/UNI_1DAY_TEEN_PATTI",
        image: "/assets/casino/1 Day teenpatti.jpeg",
      },
      {
        name: "DTL TEENPATTI",
        link: "/casino/generic/UNI_DTL_TEENPATTI",
        image: "/assets/casino/DTL.jpeg",
      },
      {
        name: "20-20 TEENPATTI",
        link: "/casino/distributed/back/generic/UNI_20_20_TEENPATTI",
        image:
          "/assets/casino/20-20 teenpatti.jpeg",
      },
    ],
    // POKER: [
    //   {
    //     name: "20-20 POKER - A",
    //     link: "/casino/poker/generic/UNI_20_20_POKER_A",
    //     image: "/assets/casino/Poker.jpeg",
    //   },
    //   {
    //     name: "20-20 POKER - B",
    //     link: "",
    //     image: "/assets/casino/Poker.jpeg",
    //   },
    // ],
    // "3 CARD JUDGEMENT": [
    //   {
    //     name: "3 CARD JUDGEMENT - A",
    //     link: "/casino/UNI_3_CARD_JUDGMENT_A",
    //     image:
    //       "https://queenexch.com/api/users/images/3Card Judgement-min-min.png",
    //   },
    // ],
    "CASINO WAR": [
      {
        name: "CASINO WAR",
        link: "/casino/UNI_CASINO_WAR",
        image: "https://queenexch.com/api/users/images/CasinoWar-min.png",
      },
    ],
    WARLI: [
      {
        name: "INSTANT WORLI",
        link: "",
        image: "https://queenexch.com/api/users/images/Instant Worli-min.png",
      },
    ],
    // LOTTERY: [
    //   {
    //     name: "LOTTERY",
    //     link: "",
    //     image: "https://queenexch.com/api/users/images/Lottery 1-min.png",
    //   },
    // ],
    // RACE: [
    //   {
    //     name: "20-20 CARD RACE",
    //     link: "/casino/generic/UNI_20_20_CARD_RACE",
    //     image: "/assets/casino/CardRace.jpeg",
    //   },
    // ],
    // OTHER: [
    //   {
    //     name: "1 CARD METER",
    //     link: "/casino/distributed/back/generic/UNI_1_CARD_METER",
    //     image: "https://queenexch.com/api/users/images/1 Card Meter-min.png",
    //   },
    //   {
    //     name: "1 CARD 20-20",
    //     link: "/casino/baccarat/generic/UNI_1_CARD_20_20",
    //     image: "https://queenexch.com/api/users/images/1 Card-min.png",
    //   },
    //   {
    //     name: "TRIO",
    //     link: "",
    //     image: "https://queenexch.com/api/users/images/Trio-min.png",
    //   },
    //   {
    //     name: "KBC",
    //     link: "",
    //     image: "https://queenexch.com/api/users/images/KBC-min.png",
    //   },
    //   {
    //     name: "CASINO METER",
    //     link: "",
    //     image: "https://queenexch.com/api/users/images/CasinoMeter-min.png",
    //   },
    // ],
    // BOLLYWOOD: [
    //   {
    //     name: "BOLLYWOOD CASINO",
    //     link: "",
    //     image:
    //       "https://queenexch.com/api/users/images/Bollywood Casino 2-min.png",
    //   },
    //   {
    //     name: "INA MINA DIKA",
    //     link: "/casino/aaa/UNI_INA_MINA_DIKA",
    //     image:
    //       "https://queenexch.com/api/users/images/InaMinaDika-01-min-min.png",
    //   },
    //   {
    //     name: "AMAR AKBAR ANTHONY",
    //     link: "/casino/aaa/UNI_AMAR_AKBAR_ANTHONY",
    //     image:
    //       "/assets/casino/AmarAkbarAnthony-01.jpeg",
    //   },
    // ],
    BACCARAT: [
      // {
      //   name: "29 CARD BACCARAT",
      //   link: "/casino/poker/generic/UNI_29_CARD_BACCARAT",
      //   image: "/assets/casino/Baccarat.jpeg",
      // },
      // {
      //   name: "BACCARAT - A",
      //   link: "/casino/baccarat/generic/UNI_BACCARAT_A",
      //   image: "/assets/casino/Baccarat.jpeg",
      // },
      {
        name: "BACCARAT",
        link: "/casino/baccarat/generic/UNI_BACCARAT",
        image: "/assets/casino/Baccarat.jpeg",
      },
      // {
      //   name: "BACCARAT - C",
      //   link: "/casino/baccarat/generic/UNI_BACCARAT_C",
      //   image: "/assets/casino/Baccarat.jpeg",
      // },
    ],
    "32CARDS": [
      {
        name: "32 CARDS - A",
        link: "/casino/generic/UNI_32_CARDS_A",
        image: "/assets/casino/32 cards.jpeg",
      },
      {
        name: "32 CARDS - B",
        link: "/casino/generic/UNI_32_CARDS_B",
        image: "/assets/casino/32 cards.jpeg",
      },
    ],
    "DRAGON TIGER": [
      {
        name: "DRAGON TIGER",
        link: "/casino/generic/UNI_DRAGON_TIGER",
        image: "/assets/casino/dragon tiger-01.jpeg",
      },
      // {
      //   name: "20-20 DRAGON TIGER",
      //   link: "/casino/distributed/back/generic/UNI_20_20_DRAGON_TIGER",
      //   image:
      //     "/assets/casino/Dragontiger.jpeg",
      // },
      // {
      //   name: "FAST DRAGON TIGER",
      //   link: "/casino/fas/UNI_FAST_DRAGON_TIGER",
      //   image:
      //     "/assets/casino/Dragontiger.jpeg",
      // },
      // {
      //   name: "1 DAY DRAGON TIGER",
      //   link: "/casino/UNI_1_DAY_DRAGON_TIGER",
      //   image:
      //     "/assets/casino/1 Day Dragon tiger.jpeg",
      // },
      {
        name: "DTL - A",
        link: "/casino/dtl/UNI_DTL_TEENPATTI",
        image: "/assets/casino/DTL.jpeg",
      },
    ],
  });
  const casinoScreenshotOrder = [
    "BALLOON", "20-20 TEENPATTI", "LUCKY 7 - A", "1DAY TEEN PATTI",
    "JOKER TEEN PATTI", "DRAGON TIGER", "BACCARAT", "ANDAR BAHAR - A",
    "32 CARDS - A", "20-20 POKER - A", "DTL - A", "1 DAY DRAGON TIGER",
    "MUFLIS TEEN PATTI", "20-20 CARD RACE", "AMAR AKBAR ANTHONY",
    "20-20 DRAGON TIGER", "HEADS & TAILS", "LUCKY 0 TO 9",
  ];
  const getCasinoGames = (games) => {
    if (games !== casinoListMap.ALL) return games;
    return [...games].sort((a, b) => {
      const aIndex = casinoScreenshotOrder.indexOf(a.name);
      const bIndex = casinoScreenshotOrder.indexOf(b.name);
      return (aIndex < 0 ? Infinity : aIndex) - (bIndex < 0 ? Infinity : bIndex);
    });
  };
  const userData = useSelector((state) => state.account.userData);
  const [selectedFilter, setSelectedFilter] = React.useState("inPlay");
  const [allGame, setAllGames] = React.useState([]);
  const handleNavigateToCasino = (link) => {
    if (userData?.token) {
      window.location.href = link;
    } else {
      toast.error("Please login to play casino games");
    }
  };
  const [filters, setFilters] = React.useState({
    inPlay: (item) => item.inPlay,
    today: (item) =>
      moment(item?.eventDate ? item?.eventDate : item?.eventTime).isSame(
        moment(),
        "day"
      ),
    tomorrow: (item) =>
      moment(item?.eventDate ? item?.eventDate : item?.eventTime).isSame(
        moment().add(1, "day"),
        "day"
      ),
  });

  const gameMap = {
    horseRacing: <HosrseRacing />,
    greyhoundRacing: <GreyHoundRacing />,
    lottery: <Lottery />,
    liveCasino: null,
    tips: <Tips />,
    virtualSports: <VirtualSports />,
  };
  const [loading, setLoading] = useState(false);
  const getSoccerMatches = async () => {
    const { response, code } = await getAllMatchesOddsSoccerAPI();
    if (code == 200) {
      setAllGames({
        ...allGame,
        soccer: response,
      });
    }
    setLoading(false);
  };
  const getTennisMatches = async () => {
    const { response, code } = await getAllMatchesOddsTennisAPI();
    if (code == 200) {
      setAllGames({
        ...allGame,
        tennis: response,
      });
    }
    setLoading(false);
  };
  const getCricketMatches = async () => {
    const { response, code } = await getAllMatchesOddsCricketAPI();
    if (code == 200) {
      setAllGames({
        ...allGame,
        cricket: [
          {
            cricketId: "ball-by-ball",
            gameId: 0,
            marketId: null,
            eventId: "28102621",
            eventName: "Ball By Ball",
            selectionId1: 0,
            runnerName1: null,
            selectionId2: 0,
            runnerName2: null,
            selectionId3: 0,
            runnerName3: null,
            eventTime: "2022-02-24T17:30",
            inPlay: true,
            tv: null,
            back1: 0,
            lay1: 0,
            back11: 0,
            lay11: 0,
            back12: 0,
            lay12: 0,
            m1: null,
            f: null,
            vir: 0,
            doesHaveFancy: false,
            doesHaveBM: false,
            doesHaveTv: false,
            marketsWithCashOutEnabled: [],
          },
          ...response,
        ],
      });
      setLoading(false);
    }
  };
  useEffect(() => {
    let interval;
    // setLoading(true);
    if (selectedGame == "cricket") {
      getCricketMatches();
      interval = setInterval(() => {
        getCricketMatches();
      }, 5000);
    } else if (selectedGame == "soccer") {
      getSoccerMatches();
      interval = setInterval(() => {
        getSoccerMatches();
      }, 5000);
    } else if (selectedGame == "tennis") {
      getTennisMatches();
      interval = setInterval(() => {
        getTennisMatches();
      }, 5000);
    } else {
      getSoccerMatches();
      getCricketMatches();
      getTennisMatches();
      interval = setInterval(() => {
        getSoccerMatches();
        getCricketMatches();
        getTennisMatches();
      }, 5000);
    }
    navigate(`/nav/${selectedGame}`);

    return () => {
      clearInterval(interval);
    };
  }, [selectedGame]);

  return (
    <app-dashboard _nghost-ng-c3019720824="">
      {showCasinoLoader && <CasinoLoader />}
      {loading && <Loader />}
      {userData?.token && (
        <div
          _ngcontent-ng-c3019720824=""
          class="col-md-12 marquee-text ng-star-inserted"
        >
          <div _ngcontent-ng-c3019720824="" class="marquee-box">
            <h4 _ngcontent-ng-c3019720824="">
              <i _ngcontent-ng-c3019720824="" class="fa fa-microphone"></i> News{" "}
            </h4>
            <div
              _ngcontent-ng-c3019720824=""
              class="scrolling-text hideDekstop"
            >
              <div _ngcontent-ng-c3019720824="" class="marquelikeDiv">
                {" "}
                Play Universe Casino For Best Odds{" "}
              </div>
            </div>
            <marquee
              _ngcontent-ng-c3019720824=""
              direction="left"
              scrollamount="5"
              behavior="scroll"
              class="hideMobile"
            >
              Play Universe Casino For Best Odds
            </marquee>
          </div>
        </div>
      )}
      <div _ngcontent-ng-c679600774="">
        <div _ngcontent-ng-c679600774="" className="custom-owl-carousel">
          <div _ngcontent-ng-c679600774="" className="custom-owl-carousel ">
            <OwlCarousel
              className="owl-theme"
              items={1}
              loop
              margin={10}
              nav
              dots
              autoplay
              autoplayTimeout={2000}
              autoplayHoverPause
            >
              <div className="item">
                <img
                  className="img img-responsive ng-star-inserted"
                  alt="slide 1"
                  src="https://queenexch.com/api/users/images/slider-default-2025221103413148.jpg"
                />
              </div>
              <div className="item">
                <img
                  alt="slide 2"
                  className="img img-responsive ng-star-inserted"
                  src="https://queenexch.com/api/users/images/slider-2024331111423488.jpg"
                />
              </div>
              <div className="item">
                <img
                  alt="slide 3"
                  className="img img-responsive ng-star-inserted"
                  src="https://queenexch.com/api/users/images/slider-default-2024108141433208.jpg"
                />
              </div>
            </OwlCarousel>
          </div>
          {/*   <owl-carousel-o
            _ngcontent-ng-c3019720824=""
            className="custom-owl-carousel"
            _nghost-ng-c2947750150=""
          >
            <div
              _ngcontent-ng-c2947750150=""
              className="owl-carousel owl-theme owl-loaded owl-responsive owl-drag"
            >
              <div
                _ngcontent-ng-c2947750150=""
                className="owl-stage-outer ng-star-inserted"
              >
                <owl-stage
                  _ngcontent-ng-c2947750150=""
                  className="ng-tns-c4272209844-0 ng-star-inserted"
                >
                  <div className="ng-tns-c4272209844-0">
                    <div
                      className="owl-stage ng-tns-c4272209844-0"
                      style={{
                        width: 2060,
                        transform: "translate3d(-824px, 0px, 0px)",
                        transition: "all",
                      }}
                    >
                      <div
                        className="owl-item ng-tns-c4272209844-0 ng-trigger ng-trigger-autoHeight cloned ng-star-inserted"
                        style={{ width: 412 }}
                      >
                        <img
                          _ngcontent-ng-c3019720824=""
                          className="img img-responsive ng-star-inserted"
                          src="https://aura444.com/api/users/images/slider-default-2024324113733565.jpg"
                          style={{}}
                        />
                        
                        
                      </div>
                      
                      <div
                        className="owl-item ng-tns-c4272209844-0 ng-trigger ng-trigger-autoHeight cloned ng-star-inserted"
                        style={{ width: 412 }}
                      >
                        <img
                          _ngcontent-ng-c3019720824=""
                          className="img img-responsive ng-star-inserted"
                          src="https://aura444.com/api/users/images/slider-default-2024324113733565.jpg"
                          style={{}}
                        />
                        
                        
                      </div>
                      
                      <div
                        className="owl-item ng-tns-c4272209844-0 ng-trigger ng-trigger-autoHeight active ng-star-inserted"
                        style={{ width: 412 }}
                      >
                        <img
                          _ngcontent-ng-c3019720824=""
                          className="img img-responsive ng-star-inserted"
                          src="https://aura444.com/api/users/images/slider-default-2024324113733565.jpg"
                          style={{}}
                        />
                        
                        
                      </div>
                      
                      <div
                        className="owl-item ng-tns-c4272209844-0 ng-trigger ng-trigger-autoHeight cloned ng-star-inserted"
                        style={{ width: 412 }}
                      >
                        <img
                          _ngcontent-ng-c3019720824=""
                          className="img img-responsive ng-star-inserted"
                          src="https://aura444.com/api/users/images/slider-default-2024324113733565.jpg"
                          style={{}}
                        />
                        
                        
                      </div>
                      
                      <div
                        className="owl-item ng-tns-c4272209844-0 ng-trigger ng-trigger-autoHeight cloned ng-star-inserted"
                        style={{ width: 412 }}
                      >
                        <img
                          _ngcontent-ng-c3019720824=""
                          className="img img-responsive ng-star-inserted"
                          src="https://aura444.com/api/users/images/slider-default-2024324113733565.jpg"
                          style={{}}
                        />
                        
                        
                      </div>
                      
                      
                    </div>
                  </div>
                </owl-stage>
              </div>
              
              <div
                _ngcontent-ng-c2947750150=""
                className="owl-nav disabled ng-star-inserted"
              >
                <div _ngcontent-ng-c2947750150="" className="owl-prev" />
                <div _ngcontent-ng-c2947750150="" className="owl-next" />
              </div>
              <div
                _ngcontent-ng-c2947750150=""
                className="owl-dots disabled ng-star-inserted"
              >
                
              </div>
              
              
            </div>
          </owl-carousel-o> */}
        </div>

        <div
          style={{
            width: "100%",
          }}
          _ngcontent-ng-c3019720824=""
          className="mobile-men onlyForMobile"
        >
          <div
            style={{
              position: "relative",
            }}
            _ngcontent-ng-c3019720824=""
            className="show-this"
          >
            <a
              _ngcontent-ng-c3019720824=""
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#searchModal"
              className="a-search"
              style={{
                position: "absolute",
                right: "-4px",
                top: "0",
                zIndex: 100,
              }}
            >
              <svg
                _ngcontent-ng-c3019720824=""
                height={22}
                viewBox="0 0 22 22"
                width={22}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  _ngcontent-ng-c3019720824=""
                  d="m29.6697865 25.8286042h-1.0026615l-.3764635-.3143021c1.191151-1.4455833 1.9434479-3.2687188 1.9434479-5.342849-.0000573-4.5258698-3.6359011-8.1714531-8.14825-8.1714531-4.4505886 0-8.0858594 3.6455833-8.0858594 8.1714531s3.6352708 8.1713959 8.1483073 8.1713959c2.0058385 0 3.886151-.7543594 5.3276094-1.948375l.3758906.3143593v1.0055261l6.2678802 6.2856406 1.8803125-1.8856979zm-7.5214792 0c-3.1339688 0-5.6411094-2.5143594-5.6411094-5.6571511 0-3.1429062 2.5071406-5.6570937 5.6411094-5.6570937 3.1338542 0 5.6410521 2.5141875 5.6410521 5.6570937 0 3.1427917-2.5071979 5.6571511-5.6410521 5.6571511z"
                  fill="currentColor"
                  transform="translate(-14 -12)"
                />
              </svg>
            </a>
            <ul
              _ngcontent-ng-c3019720824=""
              id="menuListId"
              className="menu-list"
            >
              {/* <li
                _ngcontent-ng-c3019720824=""
                className="menu-item aviator active"
                id="exchBar10122022"
              >
                <div _ngcontent-ng-c679600774="" className="exch heartBeat">
                  <img
                    _ngcontent-ng-c679600774=""
                    src="https://queenexch.com/assets/casinoslpot/aviator.png"
                    className="aviatorImg"
                  />
                
                  <span
                    _ngcontent-ng-c679600774=""
                    className="menutext orange-nav-ic-txt"
                  >
                    
                    Vimaan
                  </span>
                </div>
              </li> */}

              <li
                onClick={() => setSelectedGame("cricket")}
                _ngcontent-ng-c3019720824=""
                className={`menu-item ${
                  selectedGame == "cricket" && "active"
                } ng-star-inserted`}
                id="sportsBar0"
              >
                <div _ngcontent-ng-c3019720824="" className="ng-star-inserted">
                  <svg
                    _ngcontent-ng-c3019720824=""
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 59.35 59.35"
                    xmlSpace="preserve"
                    style={{ enableBackground: "new 0 0 59.35 59.35" }}
                    className="ng-star-inserted"
                  >
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M48.764,0.058c-2.251,2.13-12.669,11.895-12.669,11.895l1.021,1.061l-0.951,0.917
             c-1.031-0.634-2.398-0.703-3.527,0.37c-1.826,1.734-4.595,3.513-7.282,4.44c-0.173-0.203-0.345-0.409-0.518-0.612
             c3.043-1.583,8.537-4.855,8.667-4.934l0.011-0.005l-0.103-0.037l-0.289-0.108c-0.115-0.034-0.231-0.067-0.354-0.084
             c-0.416-0.055-0.874-0.008-1.367,0.17c-2.701,0.976-5.667,2.253-8.603,2.989c-3.622-2.055-8.258,3.412-5.012,7.308
             c3.026,3.631,6.169,6.927,8.513,11.001c-1.349,2.25-4.492,3.467-6.457,5.068c-3.831,3.121-4.378,8.281-5.932,12.629
             c-1.283,3.586,4.41,5.113,5.681,1.564c1.532-4.287,1.858-8.438,5.968-11.107c0.46-0.299,0.918-0.6,1.368-0.903
             c-0.597,2.252-1.079,4.519-0.74,6.96c0.412,2.966,1.276,5.878,2.278,8.693c1.261,3.554,6.955,2.022,5.68-1.565
             c-0.851-2.388-1.556-4.831-2.06-7.313c-0.82-4.032,1.353-8.114,1.998-12.174c1.086-1.263,1.547-3.072,0.59-4.963
             c-1.469-2.901-3.351-5.458-5.366-7.92c2.793-1.229,5.411-2.954,7.493-4.932c0.968-0.918,1.08-2.026,0.705-2.965l1.039-1.001
             l1.021,1.061l12.67-11.894C52.237,3.667,52.863-0.536,48.764,0.058z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M18.411,15.114c0.288-0.333,0.514-0.698,0.686-1.079l0.415-0.056
             c0.028-0.003,0.056-0.011,0.082-0.025c0.288-0.146,0.517-0.327,0.697-0.536c1.352-1.568-0.067-4.621-0.137-4.768
             c-0.059-0.125-0.209-0.179-0.336-0.121l-1.501,0.699c-0.114-0.124-0.235-0.244-0.366-0.357c-0.201-0.173-0.414-0.321-0.634-0.452
             l1.409-1.633l-0.622-0.538l-1.558,1.809c-1.672-0.596-3.608-0.15-4.837,1.274c-1.599,1.853-1.392,4.648,0.459,6.243
             C14.019,17.171,16.814,16.964,18.411,15.114z M19.401,13.482l-0.106,0.015c0.168-0.562,0.22-1.146,0.162-1.721l0.898-0.25
             C20.368,12.321,20.148,13.083,19.401,13.482z M19.793,9.1c0.15,0.366,0.424,1.121,0.524,1.918c-0.02,0.001-0.04,0.003-0.061,0.009
             l-0.88,0.245c-0.128-0.582-0.373-1.14-0.733-1.638L19.793,9.1z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M8.098,33.294c-0.564,0-1.019,0.455-1.019,1.02v20.198c0,0.563,0.455,1.021,1.019,1.021
             s1.021-0.457,1.021-1.021V34.314C9.119,33.749,8.662,33.294,8.098,33.294z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M12.14,33.294c-0.563,0-1.019,0.455-1.019,1.02v20.198c0,0.563,0.457,1.021,1.019,1.021
             c0.213,0,0.411-0.065,0.573-0.178c-0.449-0.943-0.49-2.033-0.096-3.136c0.195-0.542,0.371-1.099,0.543-1.668V34.314
             C13.161,33.749,12.705,33.294,12.14,33.294z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M15.15,34.314v10.049c0.526-1.26,1.177-2.463,2.04-3.561v-6.488c0-0.562-0.455-1.02-1.019-1.02
             C15.605,33.294,15.15,33.749,15.15,34.314z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M8.644,33.294h2.611c0.301,0,0.545-0.244,0.545-0.547c0-0.299-0.244-0.543-0.545-0.543H8.644
             c-0.302,0-0.546,0.244-0.546,0.543C8.098,33.05,8.341,33.294,8.644,33.294z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M15.625,32.204h-2.612c-0.301,0-0.545,0.244-0.545,0.543c0,0.303,0.244,0.547,0.545,0.547h2.612
             c0.301,0,0.546-0.244,0.546-0.547C16.171,32.451,15.926,32.204,15.625,32.204z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M49.427,15.243c-0.004,0.268-0.051,0.592-0.08,0.965c-0.057,0.369-0.113,0.788-0.223,1.235
             c-0.099,0.449-0.246,0.924-0.414,1.42c-0.101,0.243-0.201,0.493-0.307,0.748c-0.121,0.248-0.244,0.5-0.371,0.757
             c-0.277,0.5-0.585,1.004-0.943,1.486c-0.355,0.482-0.746,0.952-1.172,1.388c-1.688,1.769-3.815,3.033-5.463,3.798
             c-0.826,0.386-1.539,0.653-2.039,0.827c-0.504,0.171-0.787,0.245-0.787,0.245l0.16,0.567c0,0,0.31-0.091,0.818-0.282
             c0.512-0.194,1.23-0.489,2.062-0.909c1.662-0.833,3.797-2.189,5.463-4.045c0.42-0.457,0.804-0.947,1.152-1.45
             c0.35-0.5,0.646-1.024,0.912-1.54c0.121-0.265,0.238-0.525,0.354-0.779c0.099-0.261,0.193-0.517,0.285-0.766
             c0.158-0.509,0.293-0.991,0.377-1.448c0.097-0.452,0.142-0.875,0.186-1.247c0.021-0.375,0.057-0.701,0.055-0.97
             c-0.005-0.539-0.006-0.846-0.006-0.846S49.442,14.705,49.427,15.243z"
                          style={{ fill: "currentColor" }}
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Cricket{" "}
                  </span>
                </div>
              </li>
              <li
                _ngcontent-ng-c3019720824=""
                onClick={() => setSelectedGame("tennis")}
                className={`menu-item ${
                  selectedGame == "tennis" && "active"
                } ng-star-inserted`}
                id="sportsBar1"
              >
                <div
                  _ngcontent-ng-c3019720824=""
                  className="TennisClass ng-star-inserted"
                >
                  <svg
                    _ngcontent-ng-c3019720824=""
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 57.549 57.549"
                    xmlSpace="preserve"
                    style={{ enableBackground: "new 0 0 57.549 57.549" }}
                    className="ng-star-inserted"
                  >
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <circle
                          _ngcontent-ng-c3019720824=""
                          cx="32.734"
                          cy="13.533"
                          r="5.021"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M45.398,10.474c0.04-2.682-4.115-2.678-4.154,0c-0.037,2.37-0.652,7.533-3.209,8.972
        c-2.267-0.901-4.728,0.627-5.402,2.624c-0.035,0.058-0.076,0.104-0.109,0.168c-0.657,1.244-1.482,2.264-2.443,3.198
        c-1.064-1.001-1.947-2.229-2.951-3.271c-0.781-0.812-1.75-0.758-2.475-0.287l-4.211-4.538c1.574-1.904,1.015-5.333-1.373-7.908
        c-2.536-2.732-6.189-3.482-8.142-1.67c-1.952,1.812-1.477,5.511,1.058,8.243c2.391,2.574,5.767,3.387,7.783,1.958l4.224,4.551
        c-0.512,0.737-0.605,1.756,0.197,2.588c1.616,1.676,2.953,3.529,4.923,4.827c0.833,0.548,1.816,0.248,2.52-0.325
        c1.08-0.879,2.057-1.83,2.906-2.888c1.414,2.475,1.295,7.13,1.076,9.702c-0.033,0.396-0.011,0.76,0.051,1.097
        c-1.205,2.999-1.076,6.186-3.213,8.788c-1.285,1.568-2.732,3.025-4.194,4.432c-1.934,1.863,1.009,4.797,2.938,2.938
        c1.613-1.553,3.167-3.176,4.587-4.909c2.142-2.611,2.431-5.58,3.343-8.572c0.269,0.005,0.541-0.013,0.809-0.056
        c0.64,4.953,0.673,9.824-1.958,14.311c-1.356,2.317,2.235,4.408,3.59,2.098c3.763-6.42,3.087-13.353,1.94-20.475
        c-0.012-0.072-0.036-0.135-0.055-0.203c0.28-4.16-0.072-9.783-2.436-13.557C44.182,19.66,45.339,14.416,45.398,10.474z
         M12.344,15.67c-2.352-2.535-2.839-5.922-1.084-7.551s5.097-0.891,7.45,1.644c2.351,2.536,2.838,5.923,1.085,7.552
        C18.04,18.945,14.698,18.207,12.344,15.67z"
                          style={{ fill: "currentColor" }}
                        />
                        <circle
                          _ngcontent-ng-c3019720824=""
                          cx="45.962"
                          cy="1.86"
                          r="1.86"
                          style={{ fill: "currentColor" }}
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Tennis{" "}
                  </span>
                </div>
              </li>
              <li
                _ngcontent-ng-c3019720824=""
                onClick={() => setSelectedGame("soccer")}
                className={`menu-item ${
                  selectedGame == "soccer" && "active"
                } ng-star-inserted`}
                id="sportsBar2"
              >
                <div _ngcontent-ng-c3019720824="" className="ng-star-inserted">
                  <svg
                    _ngcontent-ng-c3019720824=""
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="121.51px"
                    height="121.511px"
                    viewBox="0 0 121.51 121.511"
                    xmlSpace="preserve"
                    style={{ enableBackground: "new 0 0 121.51 121.511" }}
                    className="ng-star-inserted"
                  >
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M50.116,78.373c1.407-1.311,2.471-3.025,2.933-5.182l2.508-11.705c2.988,2.607,7.471,4.384,14.276,4.384
             c3.083,0,5.581-2.499,5.581-5.581s-2.498-5.581-5.581-5.581c-8.561,0-8.806-3.124-9.396-10.67
             c-0.107-1.369-0.218-2.784-0.414-4.165c-0.037-0.26-0.098-0.51-0.167-0.755c-0.474-4.417-3.961-8.051-7.603-9.816
             c0,0-1.386-0.761-2.968-1.063c-1.514-0.289-3.268-0.299-3.268-0.299l-0.042-0.002c-1.549,0.045-3.184,0.345-4.738,0.911
             c-0.465,0.065-0.93,0.184-1.383,0.373c-0.65,0.271-16.059,6.769-27.436,16.997c-2.292,2.061-2.479,5.589-0.418,7.881
             c1.102,1.226,2.623,1.85,4.151,1.85c1.329,0,2.663-0.472,3.729-1.431c3.737-3.36,8.077-6.305,12.045-8.676l-4.676,21.822
             c-0.707,3.301,0.33,6.325,2.293,8.714c-0.916,8.861-2.363,19.01-3.217,21.102c-0.925,1.873-6.905,7.602-12.799,12.258
             c-2.857,2.259-3.345,6.406-1.087,9.265c1.302,1.647,3.231,2.508,5.181,2.508c1.431,0,2.871-0.463,4.082-1.419
             c4.273-3.374,14.466-11.839,16.806-17.556c1.099-2.683,2.088-8.349,2.856-13.894l19.582,25.549
             c1.299,1.695,3.258,2.584,5.24,2.584c1.399,0,2.812-0.443,4.007-1.36c2.893-2.216,3.439-6.356,1.225-9.248L50.116,78.373z"
                          style={{ fill: "currentColor" }}
                        />
                        <circle
                          _ngcontent-ng-c3019720824=""
                          cx="55.454"
                          cy="14.376"
                          r="14.376"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M99.393,76.6c-6.368,0-11.549,5.184-11.549,11.551s5.181,11.549,11.549,11.549c6.367,0,11.55-5.182,11.55-11.549
             S105.76,76.6,99.393,76.6z M95.846,79.462c0.085-0.167,0.459-0.901,0.771-1.51c0.115-0.229,0.224-0.439,0.305-0.595l0.039-0.078
             l0.086-0.02c1.498-0.318,3.066-0.318,4.578-0.001l0.083,0.019l0.678,1.226c0.241,0.438,0.462,0.836,0.528,0.955l0.103,0.187
             l-0.363,0.142c-0.153,0.06-0.382,0.147-0.646,0.251l-0.173,0.066c-0.735,0.287-1.68,0.655-2.127,0.828
             c-0.146,0.059-0.238,0.094-0.26,0.102l-0.067,0.027l-0.161-0.065l-2.411-0.939c-0.315-0.122-0.582-0.227-0.739-0.288
             c-0.039-0.015-0.075-0.029-0.101-0.039l-0.212-0.084L95.846,79.462z M90.98,88.27l-0.181,0.227
             c-0.14,0.175-0.239,0.302-0.28,0.351l-0.127,0.154l-0.145-0.138c-0.014-0.012-0.026-0.025-0.038-0.036l-1.291-1.248
             c-0.103-0.099-0.199-0.191-0.285-0.275l-0.258-0.25l0.009-0.088c0.146-1.534,0.607-2.995,1.373-4.346l0.043-0.077l2.765-0.479
             v0.228l0.08,1.147c0.065,0.91,0.146,2.06,0.165,2.367c0.003,0.02,0.004,0.041,0.004,0.057l0.004,0.07l-0.03,0.063
             c-0.017,0.022-0.06,0.075-0.124,0.159l-0.18,0.223C92.103,86.857,91.433,87.697,90.98,88.27z M95.784,97.863
             c-0.211,0.107-0.407,0.209-0.568,0.289l-0.076,0.039l-0.077-0.032c-1.426-0.603-2.689-1.489-3.761-2.634l-0.063-0.066l0.094-0.581
             l0.354-2.216l1.833,0.497c0.782,0.211,1.591,0.43,1.808,0.489l0.12,0.027l0.112,0.178l0.351,0.556
             c0.304,0.478,0.709,1.12,1.027,1.624l0.192,0.304c0.088,0.14,0.162,0.255,0.215,0.34l0.038,0.062
             c0.016,0.023,0.026,0.043,0.036,0.055l0.124,0.176L95.784,97.863z M97.156,91.115l-0.041-0.129
             c-0.044-0.137-0.532-1.638-0.901-2.772l-0.456-1.403l0.11-0.078c0.162-0.112,2.382-1.68,3.153-2.228
             c0.137-0.096,0.229-0.162,0.257-0.181l0.104-0.072l0.105,0.072c0.028,0.019,0.121,0.084,0.259,0.181
             c0.772,0.549,2.991,2.116,3.152,2.229l0.11,0.076l-0.053,0.174l-0.517,1.58c-0.263,0.807-0.556,1.703-0.701,2.151l-0.131,0.402
             h-4.452V91.115z M107.498,95.387c-1.054,1.167-2.368,2.112-3.81,2.735l-0.079,0.034l-0.077-0.038
             c-0.174-0.087-0.388-0.193-0.608-0.304l-1.687-0.838l2.081-3.297l0.07-0.018c0.043-0.012,0.441-0.119,0.955-0.258l1.755-0.476
             c0.366-0.1,0.656-0.179,0.766-0.208l0.183-0.049l0.063,0.178l0.081,0.438c0.064,0.352,0.154,0.85,0.233,1.297
             c0.044,0.239,0.084,0.466,0.117,0.644l0.016,0.09L107.498,95.387z M109.757,87.666l-1.379,1.332l-0.128-0.148
             c-0.019-0.02-0.042-0.051-0.071-0.092l-0.066-0.083c-0.104-0.126-0.251-0.312-0.419-0.522c-0.446-0.564-1.057-1.326-1.412-1.772
             c-0.125-0.157-0.218-0.274-0.263-0.332l-0.069-0.087l0.007-0.15l0.238-3.418c0.002-0.044,0.006-0.082,0.01-0.109l0.021-0.211
             l0.198,0.031c0.179,0.032,0.992,0.172,1.689,0.293c0.181,0.031,0.352,0.062,0.501,0.086l0.246,0.043l0.043,0.076
             c0.783,1.375,1.251,2.875,1.392,4.453l0.008,0.09l-0.065,0.062C110.1,87.333,109.936,87.493,109.757,87.666z"
                          style={{ fill: "currentColor" }}
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M84.625,92.727c-0.405,0.228-0.977,0.555-1.628,0.967c-0.668,0.395-1.41,0.916-2.21,1.455
             c-0.405,0.26-0.796,0.578-1.201,0.879c-0.403,0.307-0.813,0.617-1.223,0.928c-0.389,0.337-0.776,0.675-1.158,1.008
             c-0.374,0.341-0.771,0.635-1.1,0.993c-0.333,0.348-0.654,0.684-0.96,1.001c-0.297,0.324-0.603,0.602-0.839,0.906
             c-0.911,1.224-1.518,2.039-1.518,2.039s0.717-0.709,1.791-1.771c0.271-0.258,0.615-0.488,0.95-0.756
             c0.341-0.262,0.698-0.538,1.069-0.823c0.361-0.294,0.798-0.524,1.204-0.796c0.414-0.263,0.833-0.527,1.254-0.795
             c0.438-0.238,0.876-0.477,1.308-0.71c0.434-0.229,0.846-0.474,1.273-0.664c0.844-0.399,1.619-0.785,2.31-1.062
             c0.685-0.301,1.251-0.52,1.646-0.668c0.408-0.149,0.642-0.236,0.642-0.236l-0.99-2.236C85.245,92.384,85.02,92.509,84.625,92.727z
             "
                          style={{ fill: "currentColor" }}
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Soccer{" "}
                  </span>
                </div>
              </li>
              <li
                _ngcontent-ng-c3019720824=""
                className={`menu-item ${
                  selectedGame == "horseRacing" && "active"
                } ng-star-inserted`}
                id="sportsBar3"
                onClick={() => setSelectedGame("horseRacing")}
              >
                <div _ngcontent-ng-c3019720824="" className="ng-star-inserted">
                  <svg
                    _ngcontent-ng-c3019720824=""
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 201.705 201.705"
                    xmlSpace="preserve"
                    style={{ enableBackground: "new 0 0 201.705 201.705" }}
                    className="ng-star-inserted"
                  >
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M39.41,67.344c-2.506-2.069-1.652-7.699,1.9-12.546c3.576-4.867,8.497-7.125,11.003-5.036   c2.512,2.081,1.658,7.699-1.9,12.551C46.849,67.187,41.922,69.433,39.41,67.344z M111.832,26.914c0-4.699-3.579-8.512-7.997-8.512   c-4.43,0-8.009,3.812-8.009,8.512c0,4.69,3.579,8.497,8.009,8.497C108.264,35.423,111.832,31.616,111.832,26.914z M9.655,128.497   c-0.647,0-1.265-0.09-1.889-0.143c1.617,18.997,7.445,36.99,17.085,52.771c0.018-0.792,0-1.525,0.074-2.394l0.168-2.246   l1.755-1.401c0.092-0.076,0.29-0.213,0.538-0.378c-7.903-14.092-12.72-29.896-14.168-46.518   C12.017,128.354,10.817,128.497,9.655,128.497z M104.482,11.484c25.141,0,47.957,11.747,64.554,30.735   c0.308-0.012,0.58-0.062,0.898-0.062c1.975,0,4.02,0.136,6.101,0.396l0.118-0.142c-17.786-22.284-43.285-36.375-71.671-36.375   c-51.164,0-93.127,45.528-96.86,103.061c2.243-0.485,4.211-1.064,5.512-1.69C17.511,53.69,56.799,11.484,104.482,11.484z    M47.924,96.105c7.392-30.032,29.932-51.95,56.551-51.95c4.375,0,8.633,0.635,12.735,1.755c3.688,0.946,14.588,5.03,20.144,8.275   c1.064,0.381,1.886,0.913,2.507,1.507c0.674-0.75,1.389-1.472,2.14-2.198c-10.593-9.266-23.525-14.774-37.519-14.774   c-30.627,0-56.286,26.141-62.87,61.085c0.272,0.041,0.532,0.059,0.807,0.106C43.713,98.842,45.602,97.477,47.924,96.105z    M199.11,92.316c-0.591,3.077-1.844,5.929-4.185,7.832c0.804,5.639,1.336,11.384,1.336,17.271c0,22.2-5.899,43.373-17.041,61.401   l-22.81-14.896c0.095-0.142,0.165-0.319,0.271-0.474c-0.591,0.013-1.141,0.048-1.784,0.048c-0.958,0-1.986-0.023-3.074-0.071   l-1.466-0.07c-0.732,1.253-0.384,2.86,0.84,3.664l27.349,17.856c0.461,0.302,0.97,0.438,1.489,0.438   c0.881,0,1.762-0.438,2.282-1.229c12.69-19.422,19.387-42.48,19.387-66.691C201.699,108.778,200.753,100.396,199.11,92.316z    M58.233,162.731c-1.9,0.201-3.939,0.349-6.139,0.414c0.154,0.26,0.287,0.531,0.438,0.78l-3.298,2.151   c0.26,1.785,0.47,3.889,0.603,6.123l7.917-5.166c1.265-0.845,1.617-2.518,0.795-3.771   C58.446,163.086,58.348,162.909,58.233,162.731z M151.835,156.265c0,0-7.695,2.199-3.948-5.271l0.65-2.861   c0,0-8.789,2.648-8.789-2.866c0,0-36.479,12.081-54.06,0.437c0,0-5.491-2.866-6.809,0.656c0,0-0.659,12.307-33.18,11.645   c0,0-2.639-0.42-2.417,4.173c0,0,4.395,19.79-1.978,26.599c-6.375,6.81-8.564,9.008-9.224,4.628l-0.219-5.071   c0,0-2.42-0.881-1.761-9.215c0,0,2.196-1.762,4.619-0.65c0,0,1.971-15.829-1.54-23.087c0,0-5.932-9.883,4.838-10.982   c0,0,7.909,1.974,6.59-3.942c0,0-12.741-16.929-5.054-29.447c0,0-0.883-2.648-4.619,1.117c0,0-30.104,22.833-34.936,3.286   c0,0,14.074-0.815,18.238-5.272c4.454-4.775,13.187-7.477,25.718-4.61c0,0,14.277-14.96,36.697-8.804c0,0,8.727,2.692,18.643,2.35   c-3.215-3.603-8.571-4.347-8.571-4.347c-16.656-3.807-20.46-9.918-20.46-9.918c-5.905-6.328,4.22-14.126,4.22-14.126   c-1.058-0.63-1.894-1.691-1.894-1.691c-3.801-2.317,13.278-4.847,13.278-4.847c-0.943-3.065,27.63-3.166,27.63-3.166   c-1.466-6.537,4.433-9.909,4.433-9.909c12.649-5.29,15.604,7.784,15.604,7.784c4.209-0.201,3.382,2.397,2.577,3.003   c-0.957,0.745-3.937,0.047-4.268,1.215c-0.426,1.537,0.769,5.098-0.213,6.339c-0.33,0.417-1.737,0.63-1.737,0.63   c-1.052,2.208-0.532,3.413-1.146,3.375c-1.253-0.101-6.384-0.417-6.384-0.417c-0.633,2.326-11.396,10.974-11.396,10.974   c0.698,2.506,8.713,2.645,14.08,2.438c3.7-3.774,7.932-8.704,9.871-13.205c3.31-7.646,9.835-18.303,21.526-23.193   c0.077-0.08,0.124-0.178,0.201-0.249c0.674-0.571,1.561-0.78,2.519-0.745c5.331-1.688,11.608-2.246,19.044-0.878l7.034-8.783   l0.213,6.599l4.622-5.062l-2.565,10.988c0,0,4.988,1.756,6.159,27.55c0,0,3.228,15.817-3.807,17.579c0,0-6.064,2.323-8.926-4.602   c-3.215,0.636-7.436,1.339-12.731,1.835c-0.378,3.469-1.312,7.684-3.617,11.036c0,0-1.111,7.689,2.411,10.332   c0,0,3.954,7.252-2.411,12.513c0,0-2.424,3.299,4.397,3.299c0,0,12.081-3.299,11.856,6.164c0,0,5.935,7.685-4.385,12.969   l-9.896,6.158c0,0-4.403,1.975-14.505,1.537L151.835,156.265z M168.315,87.487c0,0,0.124,1.387,0.101,3.414   c4.238-0.405,7.802-0.943,10.651-1.478c-2.329-1.833-7.578-6.608-7.229-12.268C171.837,77.149,168.315,74.292,168.315,87.487z    M160.843,148.581c0,0,6.585,0.438,10.545-7.471C171.388,141.11,162.605,143.746,160.843,148.581z M116.962,93.655h-4.114   l1.218,1.821C115.083,94.944,116.041,94.332,116.962,93.655z"
                          data-original="#000000"
                          fill="currentColor"
                          className="active-path"
                        />
                      </g>
                    </g>
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Horse Racing{" "}
                  </span>
                </div>
              </li>
              <li
                _ngcontent-ng-c3019720824=""
                className={`menu-item ng-star-inserted ${
                  selectedGame === "greyhoundRacing" ? "active" : ""
                }`}
                id="sportsBar4"
                onClick={() => setSelectedGame("greyhoundRacing")}
              >
                <div _ngcontent-ng-c3019720824="" className="ng-star-inserted">
                  <svg
                    _ngcontent-ng-c3019720824=""
                    xmlns="http://www.w3.org/2000/svg"
                    width={18}
                    height={20}
                    viewBox="0 0 18 20"
                    fill="none"
                    className="ng-star-inserted"
                  >
                    <path
                      _ngcontent-ng-c3019720824=""
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.73413 9.63787C5.4851 8.69782 6.69752 9.6968 6.952 9.95449C5.71704 7.88027 6.88184 5.43246 6.8882 5.41853C5.33932 5.34156 3.6354 5.19601 2.60475 6.35483C0.0332312 9.24785 1.5163 9.42536 1.15894 12.1927C1.00262 13.4025 0.264445 14.3412 0.175013 14.9671C0.0988507 15.4986 -0.0776494 17.9962 0.0385025 18.6177C0.0859449 18.8729 1.10096 18.8009 1.28836 18.818C1.4156 18.041 0.877196 18.0739 0.799034 17.1656C0.572184 14.5333 1.82168 14.8128 2.49823 12.4787C2.71036 12.7064 2.7549 13.1154 2.77216 13.4415C2.79398 13.8367 2.78834 14.1929 2.77435 14.5869C2.37663 14.8726 2.42171 14.6473 2.27447 15.0819C3.95822 15.5611 2.9972 11.7826 3.04282 11.2219C3.07263 10.854 3.18824 10.704 3.32966 10.5538C5.31242 13.0073 3.5376 13.859 3.55578 14.4414C3.72755 14.8455 3.91169 14.9057 4.06092 15.4123C4.17762 15.8096 4.18562 16.1464 4.33067 16.5552C4.64641 17.4481 5.16864 17.7799 6.16856 17.5867C6.02751 16.584 5.45475 17.1211 4.91689 15.9916C4.53607 15.1919 4.46246 14.696 4.84872 13.9938C5.91099 12.0635 5.92863 12.0775 5.73413 9.63733V9.63787ZM8.59249 8.8439H8.11206V7.24613C7.9083 7.35328 7.76143 7.40685 7.54367 7.48418V6.81771C7.79324 6.70396 8.10716 6.53752 8.2344 6.28393L8.28893 6.17678H8.78862V8.8439H8.59249ZM9.63186 11.2287C9.86816 11.2372 10.1166 11.2465 10.3822 11.2671L11.0297 15.2707C11.1024 15.8421 11.1055 17.0154 11.2194 17.4503C11.2862 17.7048 11.459 17.986 11.5412 18.2764C11.6568 18.6819 11.6177 19.0164 11.7593 19.3414C12.1974 19.6093 12.7554 19.8236 13.3356 19.4981C13.3847 19.3886 13.4047 19.3731 13.3242 19.2289C12.8025 18.3182 12.3063 20.1863 11.8915 14.576C11.8582 14.1296 11.7184 12.7761 12.0187 12.3928C11.856 12.1978 11.9505 7.93938 9.6324 11.2287H9.63186ZM13.2551 18.5907C13.3096 18.7041 13.3778 19.0729 13.5009 19.0832C13.6336 19.0954 13.8226 19.1125 13.9553 19.1C14.1409 19.0821 14.57 19.0464 14.6097 18.8448C14.6989 18.6127 14.6824 18.6069 14.5055 18.4114C13.9331 17.7787 13.5439 18.7166 13.4534 15.3471C13.3602 11.8946 13.3731 12.2071 13.7292 10.2517C12.9952 9.80395 12.7869 12.2339 12.0265 12.3993C12.6756 14.246 12.4909 16.9985 13.2551 18.5907ZM13.8155 6.93683L14.5144 3.03411C14.7162 2.8532 16.2658 2.8716 16.9634 2.4805C17.4066 2.23156 17.3633 2.28317 17.44 1.90744C17.4597 1.80922 17.4582 1.83261 17.3639 1.77636C16.3678 1.17972 16.7938 1.80957 15.2917 0.618436C14.0751 -0.345011 10.9241 -0.340547 11.6279 1.77439L12.0231 1.09578C12.4337 1.61367 11.8924 2.49443 11.378 3.70986C11.1536 4.2406 11.0215 4.44508 10.516 4.6767C10.227 4.80903 9.92687 4.94671 9.63077 5.06958L9.63913 5.06619C9.64385 5.07529 10.0319 6.66467 10.9813 7.89366C11.9265 9.11784 13.4312 9.97378 13.9069 8.5187C14.0649 8.03439 13.8342 7.46114 13.8161 6.93611L13.8155 6.93683Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Greyhound Racing{" "}
                  </span>
                </div>
              </li>
              <li
                _ngcontent-ng-c3019720824=""
                className={`menu-item ng-star-inserted ${
                  selectedGame === "lottery" ? "active" : ""
                }`}
                onClick={() => setSelectedGame("lottery")}
                id="sportsBar5"
              >
                <div _ngcontent-ng-c3019720824="" className="ng-star-inserted">
                  <svg
                    _ngcontent-ng-c3019720824=""
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 511.999 511.999"
                    xmlSpace="preserve"
                    style={{ enableBackground: "new 0 0 511.999 511.999" }}
                    className="ng-star-inserted"
                  >
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M319.437,486.683l-6.2-106.699h-47.931l6.361,109.475c0.772,13.295,12.209,23.278,25.273,22.497
        C310.132,511.19,320.204,499.875,319.437,486.683z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M398.141,103.704l-36.204-91.121C357.87,2.35,346.28-2.654,336.046,1.416c-10.233,4.065-15.233,15.657-11.167,25.891
        L353.4,99.092l-47.807,16.67H288.93v-0.001c-0.08-0.134-0.161-0.269-0.243-0.402l-0.154,0.402
        c-5.986,15.638-11.314,29.557-24.365,63.655h43.764v-23.778c0,0,38.461-12.047,78.244-25.745
        C396.884,126.158,402.328,114.243,398.141,103.704z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M268.807,147.216l-8.002-14.555l7.114-12.939c1.059-1.926-0.337-4.292-2.538-4.292h-19.527
        c-2.198,0-3.599,2.362-2.538,4.292l7.114,12.939l-8.032,14.608c-0.931,1.693-1.236,3.663-0.859,5.558l5.095,25.663
        c-2.561-6.57-21.695-55.638-24.461-62.732h-21.752c-6.603,0-12.778,3.269-16.49,8.73l-29.957,44.073l-3.847-7.603
        c-4.975-9.832-17.007-13.738-26.792-8.79c-9.284,4.701-14.114,16.265-8.558,27.246h80.039l7.506-11.044v11.044h44.495h17.193
        l5.633-26.534C270.054,150.954,269.757,148.943,268.807,147.216z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M255.619,19.944c-22.821,0-41.322,18.5-41.322,41.322c0,22.86,18.564,41.322,41.322,41.322
        c22.6,0,41.322-18.318,41.322-41.322C296.941,38.445,278.44,19.944,255.619,19.944z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M197.461,379.984l-6.201,106.699c-0.796,13.694,10.078,25.314,23.907,25.314c12.579,0,23.125-9.82,23.864-22.538
        l6.361-109.475H197.461z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M388.625,279.388v8.243c2.091-0.492,3.752-1.661,3.752-3.876C392.377,281.726,390.84,280.432,388.625,279.388z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M381.242,264.13c0,1.784,1.599,2.891,3.937,3.875v-7.32C382.412,261.24,381.242,262.655,381.242,264.13z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M341.967,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
        c3.398,0,5.462-1.88,5.462-6.068v-16.082C347.429,262.2,345.366,260.319,341.967,260.319z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M307.44,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068c3.398,0,5.462-1.88,5.462-6.068
        v-16.082C312.902,262.2,310.838,260.319,307.44,260.319z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M157.258,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
        c3.398,0,5.462-1.88,5.462-6.068v-16.082C162.719,262.2,160.656,260.319,157.258,260.319z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M191.785,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
        c3.398,0,5.462-1.88,5.462-6.068v-16.082C197.247,262.2,195.183,260.319,191.785,260.319z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M272.913,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.003,6.068,5.401,6.068
        c3.398,0,5.462-1.88,5.462-6.068v-16.082C278.376,262.2,276.312,260.319,272.913,260.319z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M226.311,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
        c3.398,0,5.462-1.88,5.462-6.068v-16.082C231.774,262.2,229.71,260.319,226.311,260.319z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="currentColor"
                          d="M417.878,196.084H94.121c-8.743,0-15.831,7.087-15.831,15.831v134.46c0,8.743,7.087,15.832,15.831,15.832h323.758
        c8.743,0,15.831-7.087,15.831-15.832v-134.46C433.71,203.171,426.621,196.084,417.878,196.084z M120.12,296.427
        c-2.367,0-4.734-0.971-4.734-2.913v-30.889l-1.759,1.091c-3.556,2.372-6.515-4.22-2.731-6.494l8.01-4.854
        c0.486-0.303,1.092-0.426,1.76-0.426c1.942,0,4.187,1.153,4.187,2.974v38.598h0.001
        C124.854,295.456,122.487,296.427,120.12,296.427z M134.016,296.792c-2.67,0-4.673-2.186-4.673-4.673
        c0-2.549,2.002-4.673,4.673-4.673c2.488,0,4.613,2.124,4.613,4.673C138.629,294.606,136.504,296.792,134.016,296.792z
         M172.186,282.469c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082
        c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z M206.713,282.469
        c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323
        c8.374,0,14.928,3.884,14.928,14.323V282.469z M241.241,282.469c0,10.439-6.554,14.323-14.928,14.323
        c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z
         M249.671,296.792c-2.67,0-4.673-2.186-4.673-4.673c0-2.549,2.002-4.673,4.673-4.673c2.488,0,4.612,2.124,4.612,4.673
        C254.284,294.606,252.161,296.792,249.671,296.792z M287.842,282.469c0,10.439-6.554,14.323-14.928,14.323
        c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z
         M322.369,282.469c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082
        c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z M356.896,282.469
        c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323
        c8.374,0,14.928,3.884,14.928,14.323V282.469z M389.24,296.181v1.784c0,0.861-1.169,1.661-2.338,1.661
        c-1.353,0-2.338-0.8-2.338-1.661v-1.538c-7.382-0.247-13.41-4.059-13.41-7.997c0-2.092,1.846-5.167,4.183-5.167
        c2.584,0,4.676,3.629,9.228,4.428v-9.966c-5.66-2.154-12.304-4.798-12.304-12.673c0-7.812,5.783-11.565,12.304-12.487v-1.722
        c0-0.861,0.985-1.661,2.338-1.661c1.169,0,2.338,0.8,2.338,1.661v1.538c3.814,0.122,11.011,1.107,11.011,5.352
        c0,1.66-1.107,5.044-3.814,5.044c-2.03,0-3.198-1.968-7.197-2.277v8.982c5.598,2.091,12.119,4.983,12.119,13.287
        C401.359,290.399,396.437,295.013,389.24,296.181z"
                        />
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Lottery{" "}
                  </span>
                </div>
              </li>

              <li
                _ngcontent-ng-c3019720824=""
                className={`menu-item ng-star-inserted ${
                  selectedGame === "liveCasino" ? "active" : ""
                }`}
                onClick={() => setSelectedGame("liveCasino")}
                id="exchBar2"
              >
                <div _ngcontent-ng-c3019720824="" className="exch">
                  <svg
                    _ngcontent-ng-c3019720824=""
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 309.51 309.51"
                    xmlSpace="preserve"
                    style={{ enableBackground: "new 0 0 309.51 309.51" }}
                    className="ng-star-inserted"
                  >
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="" id="Layer_5_31_">
                        <g _ngcontent-ng-c3019720824="">
                          <path
                            _ngcontent-ng-c3019720824=""
                            d="M99.177,276.448V175.913c0-2.383-1.582-3.724-2.302-4.175c-1.638-1.026-3.021-1.993-4.052-2.861     c-4.252-3.578-7.789-7.87-9.359-14.425c-2.78-11.602,3.309-23.667,14.744-27.062c0.174-0.052,0.969-0.271,0.969-1.937V44.048     c0-9.165,4.141-17.376,10.646-22.875c0.654-0.555,1.666-1.632-1.039-0.665l-95.8,28.445c-9.573,2.842-15.078,13-12.236,22.573     l66.151,222.785c2.843,9.573,13,15.079,22.573,12.238l15.854-4.708c5.236-1.835,1.128-5.833,1.693-5.214     C102.151,291.302,99.177,284.218,99.177,276.448z M55.95,74.698c-1.432,4.742-9.86,17.511-12.295,18.234     c-2.383,0.708-16.527-5.396-20.286-8.561c-1.882-1.583-3.448-3.484-4.144-6.385c-1.23-5.135,1.664-10.538,6.727-12.041     c5.204-1.545,9.883,3.108,10.538,2.914c0.748-0.222,2.259-6.714,7.239-8.192c5.063-1.503,10.436,1.445,12.207,6.418     C56.938,69.897,56.663,72.335,55.95,74.698z"
                          />
                          <path
                            _ngcontent-ng-c3019720824=""
                            d="M187.159,14.092c3.253,0,2.324-1.439,1.97-2.116c-3.937-7.531-12.81-11.519-21.245-9.014L133.945,13.04     c0,0-3.183,1.052,0.448,1.052C148.312,14.092,187.159,14.092,187.159,14.092z"
                          />
                          <path
                            _ngcontent-ng-c3019720824=""
                            d="M292.455,37.536H140.67c-9.381,0-17.056,7.675-17.056,17.056v214.04c0,9.38,7.675,17.055,17.056,17.055h151.785     c9.38,0,17.055-7.675,17.055-18.762V54.592C309.51,46.918,301.835,37.536,292.455,37.536z M172.477,72.206     c-2.557,3.887-13.561,13.131-15.946,13.131c-2.336,0-13.44-9.277-15.98-13.131c-1.271-1.93-2.173-4.059-2.022-6.858     c0.265-4.953,4.315-9.044,9.275-9.044c5.101,0,8.069,5.441,8.711,5.441c0.732,0,3.829-5.441,8.709-5.441     c4.963,0,9.012,4.091,9.277,9.044C174.651,68.147,173.751,70.268,172.477,72.206z M252.625,165.168     c-5.774,8.783-30.636,29.667-36.025,29.667c-5.276,0-30.364-20.96-36.101-29.667c-2.872-4.359-4.91-9.169-4.573-15.492     c0.6-11.19,9.751-20.434,20.958-20.434c11.522,0,18.231,12.293,19.68,12.293c1.654,0,8.651-12.293,19.678-12.293     c11.209,0,20.359,9.244,20.957,20.434C257.536,155.998,255.505,160.79,252.625,165.168z M294.598,258.322     c-0.261,4.885-4.256,8.921-9.148,8.921c-5.029,0-7.958-5.368-8.591-5.368c-0.723,0-3.776,5.368-8.59,5.368     c-4.894,0-8.888-4.036-9.149-8.921c-0.147-2.76,0.74-4.851,1.996-6.763c2.521-3.834,13.374-12.951,15.728-12.951     c2.303,0,13.254,9.149,15.759,12.951C293.857,253.463,294.746,255.563,294.598,258.322z"
                          />
                        </g>
                      </g>
                    </g>
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                    <g _ngcontent-ng-c3019720824="" />
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Live Casino{" "}
                  </span>
                </div>
              </li>

              <li
                _ngcontent-ng-c3019720824=""
                className={`menu-item ng-star-inserted ${
                  selectedGame === "virtualSports" ? "active" : ""
                }
                }`}
                onClick={() =>
                  userData?.token && setSelectedGame("virtualSports")
                }
                id="exchBar3"
              >
                <a
                  _ngcontent-ng-c3019720824=""
                  data-bs-toggle={userData?.token ? "" : "modal"}
                >
                  <div _ngcontent-ng-c3019720824="" className="exch">
                    <svg
                      _ngcontent-ng-c3019720824=""
                      xmlns="http://www.w3.org/2000/svg"
                      id="Layer_5"
                      enableBackground="new 0 0 64 64"
                      height="512px"
                      viewBox="0 0 64 64"
                      width="512px"
                      className="virtual ng-star-inserted"
                    >
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m17.002 3c-1.841 0-3.59.74-4.883 2h9.764c-1.292-1.26-3.04-2-4.881-2z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m25.002 43.794v6.408c3.794-.835 6-2.167 6-3.202 0-.805-1.629-2.257-6-3.206z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m36.279 13.461c-.814-.677-2.135-.556-2.813.259l-5.387 6.248-7.151-.969h-3.903c-.008 0-.015.001-.023.001s-.015-.001-.023-.001h-2.978c-3.859.001-6.999 3.141-6.999 7v2.772c0 2.331 1.896 4.229 4.228 4.229.829 0 1.634-.241 2.327-.697l5.251-3.458c.521-.3.868-.662 1.031-1.054.249-.598.213-1.23-.104-1.784-.529-.924-1.816-1.271-2.724-.745l-4.738 3.22c-.497.339-1.08.519-1.686.519h-1.587v-2h1.588c.202 0 .396-.06.561-.172l4.802-3.26c2.018-1.176 4.463-.404 5.521 1.446.622 1.089.699 2.381.213 3.547-.337.809-.971 1.495-1.832 1.986l-5.196 3.425c-1.021.672-2.206 1.027-3.427 1.027-.077 0-.151-.009-.228-.012v15.582c1.494.226 3.171.372 5 .412v-13.325c0-1.336.52-2.592 1.464-3.536l.829-.829 1.414 1.416-.829.828c-.566.565-.878 1.319-.878 2.121v13.326c1.829-.041 3.506-.187 5-.412v-26.572l4.984.006h.006c1.238 0 2.41-.54 3.215-1.482l5.34-6.252c.697-.838.581-2.103-.268-2.81z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m10.002 11h3.764c.382 0 .725-.212.895-.553.444-.892 1.342-1.447 2.341-1.447.998 0 1.896.555 2.341 1.448.17.34.513.552.895.552h3.765c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1h-14c-.552 0-1 .448-1 1v2c-.001.552.447 1 .999 1z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m17.554 11.342c-.208-.419-.896-.417-1.104-.001-.513 1.023-1.541 1.659-2.684 1.659h-3.066c1.136 2.407 3.548 4 6.302 4s5.165-1.593 6.301-4h-3.066c-1.143 0-2.172-.636-2.683-1.658z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m9.002 50.202v-6.408c-4.371.949-6 2.401-6 3.206 0 1.036 2.206 2.367 6 3.202z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m3.002 50.056v.944c0 1.631 5.454 4 14 4s14-2.369 14-4v-.944c-2.879 1.94-8.459 2.944-14 2.944s-11.121-1.004-14-2.944z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m37 7h20v4h-20z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m33 3v8.561c.601-.349 1.282-.56 2-.56v-6.001h24v8h-20.551c.816 1.412.728 3.237-.372 4.56l-5.077 5.943v3.497h28v-24zm4 22h-2v-2h2zm8 0h-6v-2h6zm0-4h-6v-2h6zm0-4h-4v-2h4zm14 8h-12v-10h12z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m49 17h8v6h-8z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m3.002 54.056v2.944c0 1.631 5.454 4 14 4s14-2.369 14-4v-2.944c-2.879 1.94-8.459 2.944-14 2.944s-11.121-1.004-14-2.944z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m39 33v10h4.697l6-4h5.803l4.5-6z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m39 45h4v4h-4z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m51 41h4v8h-4z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m57 49h4v-14l-4 5.333z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="m45 49h4v-7.132l-4 2.667z"
                          data-original="#000000"
                          fill="#000000"
                          className="active-path"
                        />
                      </g>
                    </svg>

                    <span
                      _ngcontent-ng-c3019720824=""
                      className="menutext orange-nav-ic-txt"
                    >
                      {" "}
                      Virtual Sports{" "}
                    </span>
                  </div>
                </a>
              </li>

              <li
                _ngcontent-ng-c3019720824=""
                className={`menu-item ng-star-inserted ${
                  selectedGame === "tips" ? "active" : ""
                }`}
                onClick={() => setSelectedGame("tips")}
                id="exchBar4"
              >
                <div _ngcontent-ng-c3019720824="" className="exch">
                  <svg
                    _ngcontent-ng-c3019720824=""
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    width="32px"
                    height="29px"
                    viewBox="0 0 32 29"
                    enableBackground="new 0 0 32 29"
                    xmlSpace="preserve"
                    style={{ left: 0 }}
                    className="ng-star-inserted"
                  >
                    <g _ngcontent-ng-c3019720824="">
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          d="M30.289,6.177c0-1.69-0.608-3.133-1.82-4.333c-1.206-1.194-2.67-1.786-4.378-1.786H7.909    c-1.708,0-3.172,0.592-4.384,1.786c-1.206,1.2-1.814,2.643-1.814,4.333v10.524c0,1.69,0.608,3.133,1.814,4.333    c1.211,1.194,2.676,1.792,4.384,1.792h4.073c-0.248,1.657-1.116,3.178-2.603,4.564c-0.473,0.406-0.529,0.845-0.169,1.324    c0.333,0.305,0.851,0.305,1.549,0c3.77-1.104,6.75-3.064,8.948-5.888h4.383c1.708,0,3.172-0.598,4.378-1.792    c1.212-1.2,1.82-2.643,1.82-4.333V6.177z"
                        />
                      </g>
                      <g _ngcontent-ng-c3019720824="">
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="#F9E665"
                          d="M16.806,5.32l-0.034-1.285c-0.006-0.169-0.073-0.315-0.192-0.428c-0.124-0.118-0.271-0.169-0.44-0.164l0,0    c-0.168,0-0.314,0.068-0.427,0.186c-0.119,0.125-0.175,0.271-0.169,0.439l0.04,1.285c0,0.168,0.067,0.31,0.186,0.428    c0.124,0.113,0.27,0.168,0.439,0.164h0.006c0.163,0,0.31-0.068,0.422-0.192C16.75,5.636,16.806,5.49,16.806,5.32z"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="#F9E665"
                          d="M21.105,5.382c-0.169,0.005-0.311,0.067-0.428,0.192l-0.885,0.924c-0.119,0.119-0.174,0.265-0.174,0.433    c0.005,0.169,0.067,0.311,0.185,0.429h0.006c0.119,0.118,0.265,0.174,0.434,0.168c0.169,0,0.31-0.062,0.428-0.186l0.891-0.924    c0.112-0.118,0.168-0.265,0.168-0.434c-0.006-0.169-0.067-0.31-0.186-0.428h-0.005C21.42,5.439,21.273,5.382,21.105,5.382z"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="#F9E665"
                          d="M23.105,9.546l-1.234,0.338c-0.164,0.045-0.287,0.141-0.366,0.287c-0.084,0.146-0.101,0.304-0.057,0.462    v0.006c0.045,0.164,0.141,0.281,0.288,0.366c0.146,0.079,0.299,0.101,0.462,0.056l1.234-0.343    c0.163-0.045,0.287-0.141,0.366-0.287c0.085-0.147,0.102-0.299,0.057-0.462l0,0c-0.045-0.164-0.141-0.288-0.287-0.372    C23.42,9.518,23.269,9.496,23.105,9.546z"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="#F9E665"
                          d="M21.189,13.625c-0.135,0.107-0.215,0.236-0.231,0.406v0.006c-0.028,0.164,0.012,0.315,0.119,0.445    c0.102,0.135,0.236,0.213,0.406,0.236l1.262,0.169c0.169,0.017,0.321-0.022,0.457-0.125c0.129-0.101,0.209-0.236,0.226-0.4    l0.006-0.006c0.017-0.163-0.022-0.315-0.119-0.451c-0.107-0.129-0.242-0.208-0.406-0.23l-1.268-0.169    C21.471,13.484,21.325,13.523,21.189,13.625z"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="#F9E665"
                          d="M10.106,5.968c-0.006,0.169,0.051,0.315,0.169,0.439l0.89,0.924c0.113,0.118,0.26,0.18,0.428,0.186    c0.164,0,0.311-0.057,0.434-0.169V7.343c0.124-0.113,0.186-0.26,0.192-0.428c0-0.164-0.057-0.31-0.175-0.434l-0.884-0.924    c-0.119-0.118-0.266-0.186-0.428-0.186c-0.169-0.006-0.316,0.056-0.44,0.169v0.005C10.174,5.658,10.106,5.805,10.106,5.968z"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="#F9E665"
                          d="M8.202,10.414c0.084,0.152,0.208,0.248,0.372,0.293l1.234,0.338c0.157,0.045,0.315,0.029,0.456-0.056    c0.152-0.08,0.248-0.203,0.293-0.361v-0.006c0.045-0.164,0.022-0.315-0.056-0.467c-0.085-0.141-0.208-0.237-0.366-0.282    L8.901,9.529C8.737,9.484,8.58,9.501,8.433,9.585C8.287,9.664,8.191,9.789,8.151,9.952v0.006    C8.101,10.115,8.123,10.272,8.202,10.414z"
                        />
                        <path
                          _ngcontent-ng-c3019720824=""
                          fill="#F9E665"
                          d="M10.174,14.701c0.164-0.022,0.299-0.101,0.401-0.231c0.106-0.135,0.146-0.281,0.124-0.451l0,0    c-0.023-0.169-0.102-0.305-0.237-0.406c-0.129-0.101-0.281-0.141-0.451-0.119l-1.262,0.169c-0.168,0.017-0.304,0.096-0.405,0.231    c-0.101,0.129-0.141,0.287-0.118,0.451v0.006c0.017,0.163,0.096,0.292,0.23,0.394c0.13,0.107,0.282,0.147,0.451,0.124    L10.174,14.701z"
                        />
                        <g _ngcontent-ng-c3019720824="">
                          <path
                            _ngcontent-ng-c3019720824=""
                            fill="#F9E665"
                            d="M16.006,7.433c-1.178,0-2.186,0.423-3.02,1.273c-0.834,0.846-1.251,1.871-1.251,3.071     c0,1.082,0.344,2.022,1.026,2.823c0.461,0.603,0.789,1.278,0.968,2.022l3.978-0.226c0.35-0.485,0.71-0.93,1.087-1.335     c0.079-0.068,0.152-0.14,0.231-0.214c0.833-0.851,1.251-1.876,1.251-3.071c0-1.2-0.417-2.225-1.251-3.071     C18.192,7.856,17.188,7.433,16.006,7.433z"
                          />
                          <path
                            _ngcontent-ng-c3019720824=""
                            fill="#F9E665"
                            d="M14.293,18.78c0.315,0.423,0.8,0.654,1.442,0.688c0.637-0.09,1.122-0.377,1.449-0.862L14.293,18.78z"
                          />
                          <path
                            _ngcontent-ng-c3019720824=""
                            fill="#F9E665"
                            d="M13.825,17.26c0.018,0.332,0.068,0.625,0.147,0.885l3.538-0.226c0.045-0.146,0.08-0.304,0.113-0.468     c0.011-0.141,0.022-0.287,0.028-0.428L13.825,17.26z"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>

                  <span
                    _ngcontent-ng-c3019720824=""
                    className="menutext orange-nav-ic-txt"
                  >
                    {" "}
                    Tips &amp; Previews{" "}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          _ngcontent-ng-c3019720824=""
          className="col-md-12 mobile-display-view"
        >
          <div _ngcontent-ng-c3019720824="" className="game-highlight-wrap">
            <h3 _ngcontent-ng-c3019720824="" className="hideDesktop">
              Highlights
            </h3>
            <div
              _ngcontent-ng-c3019720824=""
              className="game-menu-tab homeevent tab-container"
            >
              <ul
                _ngcontent-ng-c3019720824=""
                className="nav nav-tabs hideDesktop"
              >
                <li _ngcontent-ng-c3019720824="" className="nav-item">
                  <a
                    _ngcontent-ng-c3019720824=""
                    id=""
                    onClick={() => setSelectedGame("cricket")}
                    className={`nav-link ${
                      selectedGame == "cricket" && "active"
                    }`}
                  >
                    <span _ngcontent-ng-c3019720824="">Cricket</span>
                  </a>
                </li>
                <li _ngcontent-ng-c3019720824="" className="nav-item">
                  <a
                    onClick={() => setSelectedGame("soccer")}
                    _ngcontent-ng-c3019720824=""
                    id=""
                    className={`nav-link ${
                      selectedGame == "soccer" && "active"
                    }`}
                  >
                    <span _ngcontent-ng-c3019720824="">Soccer</span>
                  </a>
                </li>
                <li _ngcontent-ng-c3019720824="" className="nav-item">
                  <a
                    onClick={() => setSelectedGame("tennis")}
                    _ngcontent-ng-c3019720824=""
                    id=""
                    className={`nav-link ${
                      selectedGame == "tennis" && "active"
                    }`}
                  >
                    <span _ngcontent-ng-c3019720824="">Tennis</span>
                  </a>
                </li>
              </ul>
              {["soccer", "tennis", "cricket"].includes(selectedGame) ? (
                <div _ngcontent-ng-c3019720824="" className="tab-content">
                  <div
                    _ngcontent-ng-c3019720824=""
                    heading="Cricket"
                    className="active tab-pane"
                  >
                    <div _ngcontent-ng-c3019720824="" className="row">
                      <div
                        _ngcontent-ng-c3019720824=""
                        className="col-md-12 mobile-width scrollHeight"
                      >
                        <table
                          _ngcontent-ng-c3019720824=""
                          className="table table-hover dashboard-custom-table"
                          style={{ borderBottom: "1px solid #c8ced3" }}
                        >
                          <thead
                            _ngcontent-ng-c3019720824=""
                            className="hideDesktop"
                          >
                            <tr>
                              <th
                                _ngcontent-ng-c3019720824=""
                                colspan="2"
                                class="view-mobile"
                              ></th>
                              <th
                                _ngcontent-ng-c3019720824=""
                                className="text-center"
                              >
                                <span _ngcontent-ng-c3019720824="">1</span>
                              </th>
                              <th
                                _ngcontent-ng-c3019720824=""
                                className="text-center"
                              >
                                <span _ngcontent-ng-c3019720824="">X</span>
                              </th>
                              <th
                                _ngcontent-ng-c3019720824=""
                                className="text-center"
                              >
                                <span _ngcontent-ng-c3019720824="">2</span>
                              </th>
                              <th
                                _ngcontent-ng-c3019720824=""
                                className="text-center"
                              ></th>
                            </tr>
                          </thead>
                          <tbody
                            _ngcontent-ng-c3019720824=""
                            className="tbody-custom ng-star-inserted"
                          >
                            {["cricket", "soccer", "tennis"].includes(
                              selectedGame
                            ) &&
                              allGame[selectedGame]
                                ?.sort((a, b) => {
                                  if (a.inPlay || b.inPlay) {
                                    return b.inPlay - a.inPlay;
                                  }
                                  const currentDate = new Date();
                                  const dateA = new Date(
                                    a.eventDate ? a.eventDate : a.eventTime
                                  );
                                  const dateB = new Date(
                                    b.eventDate ? b.eventDate : b.eventTime
                                  );

                                  // If both are future dates, sort them normally
                                  if (
                                    dateA > currentDate &&
                                    dateB > currentDate
                                  ) {
                                    return dateA - dateB;
                                  }
                                  // If one is future and one is past, put future at the end
                                  if (dateA > currentDate) return 1;
                                  if (dateB > currentDate) return -1;
                                  // If both are past dates, sort them normally
                                  return dateB - dateA;
                                })
                                ?.map((item) => (
                                  <tr
                                    _ngcontent-ng-c3019720824=""
                                    id="market0"
                                    onClick={() => {
                                      navigate(
                                        `/game/${selectedGame}/${
                                          item[selectedGame + "Id"]
                                        }`
                                      );
                                    }}
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-ng-c3019720824=""
                                      className="td-event-name"
                                    >
                                      <a
                                        _ngcontent-ng-c3019720824=""
                                        className="match-name"
                                      >
                                        <span _ngcontent-ng-c3019720824="">
                                          {item?.eventName}
                                        </span>
                                      </a>

                                      {item?.inPlay ? (
                                        <span
                                          _ngcontent-ng-c3019720824=""
                                          class="in_play ng-star-inserted"
                                        >
                                          In-Play
                                        </span>
                                      ) : (
                                        <p
                                          _ngcontent-ng-c3019720824=""
                                          className="match-time ng-star-inserted"
                                        >
                                          {moment(
                                            item?.eventDate
                                              ? item?.eventDate
                                              : item?.eventTime
                                          ).format("DD/MM/YYYY HH:mm")}
                                        </p>
                                      )}
                                    </td>
                                    <td
                                      _ngcontent-ng-c3019720824=""
                                      class="fancy-and-sport-book-chips"
                                    >
                                      {item?.doesHaveBM ? (
                                        <span
                                          _ngcontent-ng-c3019720824=""
                                          class="game-bookmakers me-lg-1 ng-star-inserted"
                                        >
                                          BM
                                        </span>
                                      ) : null}
                                      {item?.doesHaveFancy ? (
                                        <span
                                          _ngcontent-ng-c3019720824=""
                                          class="game-fancy me-1 ng-star-inserted"
                                        >
                                          F
                                        </span>
                                      ) : null}
                                      {selectedGame == "cricket" && (
                                        <span
                                          _ngcontent-ng-c3019720824=""
                                          class="game-sportbook ng-star-inserted"
                                        >
                                          S
                                        </span>
                                      )}
                                    </td>
                                    <td
                                      _ngcontent-ng-c3019720824=""
                                      className="count hideDesktop"
                                    >
                                      <span
                                        _ngcontent-ng-c3019720824=""
                                        className="back"
                                      >
                                        {item?.back1 ? item.back1 : "--"}
                                      </span>
                                      <span
                                        _ngcontent-ng-c3019720824=""
                                        className="lay"
                                      >
                                        {" "}
                                        {item?.lay1 ? item.lay1 : "--"}
                                      </span>
                                    </td>
                                    <td
                                      _ngcontent-ng-c3019720824=""
                                      className="count hideDesktop custom-width-center"
                                    >
                                      <span
                                        _ngcontent-ng-c3019720824=""
                                        className="back"
                                      >
                                        {" "}
                                        {item?.back11 ? item?.back11 : "--"}
                                      </span>
                                      <span
                                        _ngcontent-ng-c3019720824=""
                                        className="lay"
                                      >
                                        {item?.lay11 ? item.lay11 : "--"}
                                      </span>
                                    </td>
                                    <td
                                      _ngcontent-ng-c3019720824=""
                                      className="count hideDesktop custom-width-end"
                                    >
                                      <span
                                        _ngcontent-ng-c3019720824=""
                                        className="back"
                                      >
                                        {" "}
                                        {item?.back12 ? item?.back12 : "--"}
                                      </span>
                                      <span
                                        _ngcontent-ng-c3019720824=""
                                        className="lay"
                                      >
                                        {item?.lay12 ? item?.lay12 : "--"}
                                      </span>
                                    </td>
                                    <td
                                      _ngcontent-ng-c3019720824=""
                                      style={{ width: "25px" }}
                                    >
                                      <a
                                        _ngcontent-ng-c3019720824=""
                                        id="multiMarketPin"
                                        title="Add to Multi Markets"
                                        style={{ cursor: "pointer" }}
                                        className="add-pin 4002024910195819444"
                                      >
                                        <svg
                                          _ngcontent-ng-c3019720824=""
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={25}
                                          height={25}
                                          viewBox="0 0 25 25"
                                        >
                                          <path
                                            _ngcontent-ng-c3019720824=""
                                            fill="currentColor"
                                            d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                                          />
                                        </svg>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                gameMap[selectedGame]
              )}
            </div>
          </div>
          <div _ngcontent-ng-c3019720824="" className="inplay-match">
            <div _ngcontent-ng-c3019720824="" className="row">
              <div
                _ngcontent-ng-c3019720824=""
                className="col-md-12 mobile-width"
              >
                <div _ngcontent-ng-c3019720824="" className="inplay-sportwise">
                  <app-live-casino
                    _ngcontent-ng-c679600774=""
                    _nghost-ng-c898714788=""
                  >
                    <div
                      _ngcontent-ng-c898714788=""
                      className="position-relative mobile-men"
                    >
                      <ul
                        _ngcontent-ng-c898714788=""
                        id="menuListId"
                        className="menu-list"
                      >
                        {casinoList?.map((casino) => (
                          <li
                            _ngcontent-ng-c898714788=""
                            className={`menu-item ${
                              casino.active ? "active" : ""
                            } ng-star-inserted`}
                            id="sportsBar0"
                            onClick={() => {
                              setCasinoList((prev) =>
                                prev.map((item) => {
                                  item.active = item.name === casino.name;
                                  return item;
                                })
                              );
                            }}
                          >
                            <div _ngcontent-ng-c898714788="">
                              <span
                                _ngcontent-ng-c898714788=""
                                className="menutext orange-nav-ic-txt"
                              >
                                {casino.name}
                              </span>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                    {casinoList?.find((item) => item.active) &&
                      casinoList?.find((item) => item.active)?.enum && (
                        <div
                          _ngcontent-ng-c898714788=""
                          className="position-relative ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c898714788=""
                            id="home"
                            className="tab-pane sports active"
                          >
                            <ul
                              _ngcontent-ng-c898714788=""
                              id="menuSubListId"
                              className="nav nav-tabs-casino game-nav-bar menu-list-casino"
                            >
                              {casinoList
                                ?.find((item) => item.active)
                                ?.enum.map((casino) => (
                                  <li
                                    _ngcontent-ng-c898714788=""
                                    className="nav-item casinoname-item mainTabs text-center aaa ng-star-inserted"
                                    id="sportsBarSub0"
                                    onClick={() => {
                                      setCasinoList((prev) =>
                                        prev.map((item) => {
                                          item?.enum?.map((sub) => {
                                            sub.active =
                                              sub.name === casino.name;
                                            return sub;
                                          });
                                          return item;
                                        })
                                      );
                                    }}
                                  >
                                    <a
                                      _ngcontent-ng-c898714788=""
                                      className={`nav-link 
                                  ${casino?.active ? "active" : ""}
                                }`}
                                    >
                                      <div _ngcontent-ng-c898714788="">
                                        {casino.name}
                                      </div>
                                    </a>
                                  </li>
                                ))}
                            </ul>
                          </div>
                          <div _ngcontent-ng-c898714788="">
                            <div
                              _ngcontent-ng-c898714788=""
                              className="searchBox"
                            >
                              <a _ngcontent-ng-c898714788="">
                                <i
                                  _ngcontent-ng-c898714788=""
                                  className="fas fa-search ng-star-inserted"
                                />
                                {/**/}
                                {/**/}
                              </a>
                            </div>
                            <div
                              _ngcontent-ng-c898714788=""
                              className="searchInput hideSearchBar"
                            >
                              <input
                                _ngcontent-ng-c898714788=""
                                id="CasinolobbySearch"
                                name="search"
                                placeholder="Search..."
                                type="text"
                                className="form-control ng-untouched ng-pristine ng-valid"
                              />
                            </div>
                          </div>
                        </div>
                      )}

                    <div _ngcontent-ng-c898714788="" className="main-con">
                      <div _ngcontent-ng-c898714788="" className="row home">
                        {casinoList?.find((item) => item?.active)?.enum
                          ? getCasinoGames(casinoListMap[
                              casinoList
                                ?.find((item) => item?.active)
                                ?.enum?.find((a) => a.active)?.value
                            ])?.map((casino) => (
                              <div
                                _ngcontent-ng-c898714788=""
                                className="col col-4 col-md-3 col-sm-3 col-xl-3 pointer ng-star-inserted"
                              >
                                <div
                                  _ngcontent-ng-c898714788=""
                                  className="casinoicons"
                                >
                                  <a
                                    _ngcontent-ng-c898714788=""
                                    onClick={() => {
                                      if (casino.link && casino.link != "") {
                                        setShowCasinoLoader(true);
                                        setTimeout(() => {
                                          navigate(casino.link);
                                        }, 1500);
                                      }
                                    }}
                                  >
                                    <img
                                      _ngcontent-ng-c898714788=""
                                      className="img-fluid"
                                      src={casino.image}
                                      alt={casino.name}
                                    />

                                    {/* <div
                                      _ngcontent-ng-c898714788=""
                                      className="casino-bottom"
                                    >
                                      {" "}
                                      {casino.name}{" "}
                                    </div> */}

                                  </a>
                                </div>
                              </div>
                            ))
                          : getCasinoGames(casinoListMap[
                              casinoList?.find((item) => item.active)?.name
                            ])?.map((casino) => (
                              <div
                                _ngcontent-ng-c898714788=""
                                className="col col-4 col-md-3 col-sm-3 col-xl-3 pointer ng-star-inserted"
                              >
                                <div
                                  _ngcontent-ng-c898714788=""
                                  className="casinoicons"
                                >
                                  <a
                                    _ngcontent-ng-c898714788=""
                                    onClick={() => {
                                      if (casino.link && casino.link != "") {
                                        setShowCasinoLoader(true);
                                        setTimeout(() => {
                                          navigate(casino.link);
                                        }, 1500);
                                      }
                                    }}
                                  >
                                    <img
                                      _ngcontent-ng-c898714788=""
                                      className="img-fluid"
                                      src={casino.image}
                                      alt={casino.name}
                                    />
                                    {/* <div
                                      _ngcontent-ng-c898714788=""
                                      className="casino-bottom"
                                    >
                                      {" "}
                                      {casino.name}{" "}
                                    </div> */}
                                  </a>
                                </div>
                              </div>
                            ))}
                      </div>
                    </div>
                  </app-live-casino>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedModal && modalMap[selectedModal]}
      <app-footer-desktop _ngcontent-ng-c3019720824="" _nghost-ng-c875931659="">
        <div _ngcontent-ng-c875931659="" className="col-md-12 footerDiv main">
          <div _ngcontent-ng-c875931659="" className="inner-footer">
            <div _ngcontent-ng-c875931659="" className="support-wrap">
              <dl _ngcontent-ng-c875931659="" className="support-mail">
                <a
                  _ngcontent-ng-c875931659=""
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  className="rules-btn-home"
                  onClick={() => {
                    setSelectedModal("pp");
                  }}
                >
                  {" "}
                  Privacy Policy{" "}
                </a>
                <a
                  _ngcontent-ng-c875931659=""
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  className="rules-btn-home arrow"
                  onClick={() => {
                    setSelectedModal("rar");
                  }}
                >
                  {" "}
                  Rules and Regulations{" "}
                </a>
                <a
                  _ngcontent-ng-c875931659=""
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setSelectedModal("kyc");
                  }}
                  className="rules-btn-home arrow"
                >
                  {" "}
                  KYC{" "}
                </a>
                <a
                  _ngcontent-ng-c875931659=""
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  className="rules-btn-home arrow"
                  onClick={() => {
                    setSelectedModal("responsibleGaming");
                  }}
                >
                  {" "}
                  Terms and Conditions{" "}
                </a>
                <a
                  _ngcontent-ng-c875931659=""
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  className="rules-btn-home arrow"
                  onClick={() => {
                    setSelectedModal("responsibleGaming");
                  }}
                >
                  {" "}
                  Responsible Gambling{" "}
                </a>
              </dl>
            </div>
            <div _ngcontent-ng-c875931659="" className="extra-wrap">
              <div
                _ngcontent-ng-c875931659=""
                className="appdl-link-android"
                style={{ display: "block" }}
              >
                <a _ngcontent-ng-c875931659="" target="_blank">
                  <img
                    _ngcontent-ng-c875931659=""
                    alt=""
                    src="https://uniique444.com/assets/androidapk.png"
                  />
                </a>
                {/**/}
                {/**/}
              </div>
            </div>
          </div>
        </div>
      </app-footer-desktop>
      <div
        _ngcontent-ng-c3019720824=""
        id="searchModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="searchModal"
        aria-hidden="true"
        className="modal fade ch-pass-model"
      >
        <div
          _ngcontent-ng-c3019720824=""
          role="document"
          className="modal-dialog"
        >
          <div _ngcontent-ng-c3019720824="" className="modal-content">
            <div _ngcontent-ng-c3019720824="" className="modal-body p-2">
              <div _ngcontent-ng-c3019720824="" className="searchIconDiv">
                <i
                  _ngcontent-ng-c3019720824=""
                  aria-hidden="true"
                  className="fa fa-search searchIcon"
                />
                <input
                  _ngcontent-ng-c3019720824=""
                  autoComplete="off"
                  autofocus=""
                  type="text"
                  placeholder=""
                  aria-label="Search"
                  id="myInputHeaderInMobile"
                  className="form-control searchbar ng-untouched ng-pristine ng-valid"
                />
                <span
                  _ngcontent-ng-c3019720824=""
                  aria-hidden="true"
                  id="myClose"
                  className="searchIconCross 123123"
                >
                  ×
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        _ngcontent-ng-c3019720824=""
        id="changePasswordModal"
        tabIndex={-1}
        aria-labelledby="changePasswordModalLabel"
        aria-hidden="true"
        className="modal fade"
      >
        <div _ngcontent-ng-c3019720824="" className="modal-dialog">
          <div _ngcontent-ng-c3019720824="" className="modal-content">
            <div
              _ngcontent-ng-c3019720824=""
              className="modal-header account-detail-head"
            >
              <h5 _ngcontent-ng-c3019720824="" className="modal-title">
                Change Password
              </h5>
            </div>
            <div _ngcontent-ng-c3019720824="" className="modal-body">
              <div _ngcontent-ng-c3019720824="" className="row">
                <div _ngcontent-ng-c3019720824="" className="col-md-6">
                  <div _ngcontent-ng-c3019720824="" className="form-group">
                    <label _ngcontent-ng-c3019720824="" htmlFor="oldPassword">
                      Old Password{" "}
                      <span
                        _ngcontent-ng-c3019720824=""
                        className="asterisk_input"
                      />
                    </label>
                    <div _ngcontent-ng-c3019720824="" className="input-group">
                      <input
                        _ngcontent-ng-c3019720824=""
                        id="oldPassword"
                        name="oldPassword"
                        placeholder="Old Password.."
                        required=""
                        className="form-control ng-untouched ng-pristine ng-invalid"
                        type="password"
                      />
                      <div
                        _ngcontent-ng-c3019720824=""
                        className="input-group-append"
                      >
                        <button
                          _ngcontent-ng-c3019720824=""
                          type="button"
                          className="btn btn-outline-secondary"
                          style={{ border: "none", zIndex: 999 }}
                        >
                          <i
                            _ngcontent-ng-c3019720824=""
                            className="fa fa-eye-slash"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c3019720824="" className="col-md-6">
                  <div _ngcontent-ng-c3019720824="" className="form-group">
                    <label _ngcontent-ng-c3019720824="" htmlFor="newPassword">
                      New Password{" "}
                      <span
                        _ngcontent-ng-c3019720824=""
                        className="asterisk_input"
                      />
                    </label>
                    <div _ngcontent-ng-c3019720824="" className="input-group">
                      <input
                        _ngcontent-ng-c3019720824=""
                        id="newPassword"
                        name="newPassword"
                        pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&]{8,}$"
                        placeholder="New Password.."
                        required=""
                        className="form-control ng-untouched ng-pristine ng-invalid"
                        type="password"
                      />
                      <div
                        _ngcontent-ng-c3019720824=""
                        className="input-group-append"
                      >
                        <button
                          _ngcontent-ng-c3019720824=""
                          type="button"
                          className="btn btn-outline-secondary"
                          style={{ border: "none", zIndex: 999 }}
                        >
                          <i
                            _ngcontent-ng-c3019720824=""
                            className="fa fa-eye-slash"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c3019720824="" className="col-md-6">
                  <div _ngcontent-ng-c3019720824="" className="form-group">
                    <label _ngcontent-ng-c3019720824="" htmlFor="confirmPass">
                      Confirm Password{" "}
                      <span
                        _ngcontent-ng-c3019720824=""
                        className="asterisk_input"
                      />
                    </label>
                    <div _ngcontent-ng-c3019720824="" className="input-group">
                      <input
                        _ngcontent-ng-c3019720824=""
                        id="confirmPass"
                        name="confirmPass"
                        placeholder="Confirm Password.."
                        required=""
                        className="form-control ng-untouched ng-pristine ng-invalid"
                        type="password"
                      />
                      <div
                        _ngcontent-ng-c3019720824=""
                        className="input-group-append"
                      >
                        <button
                          _ngcontent-ng-c3019720824=""
                          type="button"
                          className="btn btn-outline-secondary"
                          style={{ border: "none", zIndex: 999 }}
                        >
                          <i
                            _ngcontent-ng-c3019720824=""
                            className="fa fa-eye-slash"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c3019720824="" className="modal-footer">
              <button
                _ngcontent-ng-c3019720824=""
                type="submit"
                className="btn btn-primary"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </app-dashboard>
  );
}
